// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1904U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Chevron);
var _jsxRuntime = require("react/jsx-runtime");
var _s2ChevronSize200Svg = require("./S2_ChevronSize200.svg");
var _s2ChevronSize200SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize200Svg);
var _s2ChevronSize100Svg = require("./S2_ChevronSize100.svg");
var _s2ChevronSize100SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize100Svg);
var _s2ChevronSize75Svg = require("./S2_ChevronSize75.svg");
var _s2ChevronSize75SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize75Svg);
var _s2ChevronSize300Svg = require("./S2_ChevronSize300.svg");
var _s2ChevronSize300SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize300Svg);
var _s2ChevronSize50Svg = require("./S2_ChevronSize50.svg");
var _s2ChevronSize50SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize50Svg);
var _s2ChevronSize400Svg = require("./S2_ChevronSize400.svg");
var _s2ChevronSize400SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize400Svg);
let styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zi12';
    else if (props.size === "XS") rules += ' Zg12';
    else if (props.size === "XXL") rules += ' Zu12';
    else if (props.size === "XL") rules += ' Zk12';
    else if (props.size === "L") rules += ' Zj12';
    else if (props.size === "M") rules += ' Zi12';
    if (props.size === "S") rules += ' Fj12';
    else if (props.size === "XS") rules += ' Fg12';
    else if (props.size === "XXL") rules += ' Ft12';
    else if (props.size === "XL") rules += ' Fl12';
    else if (props.size === "L") rules += ' Fk12';
    else if (props.size === "M") rules += ' Fj12';
    return rules;
};
function Chevron(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize100SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize200SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize300SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize400SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize50SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize75SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
    }
}

},{"0":"7QEO0","react/jsx-runtime":"2Is6Z","./S2_ChevronSize200.svg":"2DMXy","./S2_ChevronSize100.svg":"6nICH","./S2_ChevronSize75.svg":"9RcBK","./S2_ChevronSize300.svg":"9zxAm","./S2_ChevronSize50.svg":"l8cnR","./S2_ChevronSize400.svg":"7bwDG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7QEO0":[function() {},{}],"2DMXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M9.301 6c0-.049-.02-.095-.028-.143-.01-.068-.013-.136-.039-.2a.9.9 0 0 0-.2-.302L4.343.663a.912.912 0 0 0-1.29 1.29L7.102 6l-4.047 4.048a.912.912 0 0 0 1.289 1.289l4.691-4.692a.9.9 0 0 0 .2-.302c.026-.064.028-.132.04-.2C9.28 6.095 9.3 6.05 9.3 6"
        })
    });
exports.default = SvgS2ChevronSize200;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6nICH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.965 5.178C7.978 5.118 8 5.061 8 5s-.021-.118-.034-.178c-.01-.05-.01-.102-.03-.15-.023-.058-.068-.107-.104-.16-.03-.042-.047-.09-.084-.127l-.004-.003-.003-.004L3.615.303a.875.875 0 1 0-1.23 1.244L5.88 5 2.385 8.453a.875.875 0 1 0 1.23 1.244L7.74 5.622l.003-.004.004-.003c.037-.038.055-.085.084-.127.036-.053.08-.102.104-.16.02-.048.02-.1.03-.15"
        })
    });
exports.default = SvgS2ChevronSize100;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9RcBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.483 4.406 3.86.783a.84.84 0 1 0-1.188 1.188L5.702 5l-3.03 3.03A.84.84 0 1 0 3.86 9.216l3.623-3.623a.84.84 0 0 0 0-1.188"
        })
    });
exports.default = SvgS2ChevronSize75;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9zxAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.361 6.328 5.03.996a.954.954 0 0 0-1.343 0 .95.95 0 0 0 0 1.344L8.346 7l-4.66 4.66a.95.95 0 0 0 1.344 1.344l5.331-5.332a.95.95 0 0 0 0-1.344"
        })
    });
exports.default = SvgS2ChevronSize300;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l8cnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 6,
        viewBox: "0 0 6 6",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M1.985 5.961a.695.695 0 0 1-.7-.704.7.7 0 0 1 .209-.493L3.279 3 1.51 1.251A.7.7 0 0 1 1.3.757.696.696 0 0 1 2.492.255l2.275 2.247a.7.7 0 0 1 0 .996L2.477 5.76a.7.7 0 0 1-.492.201"
        })
    });
exports.default = SvgS2ChevronSize50;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7bwDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M11.726 7.3 5.67 1.247A.988.988 0 1 0 4.27 2.645L9.628 8 4.27 13.355a.988.988 0 1 0 1.399 1.399l6.056-6.055a.99.99 0 0 0 0-1.398"
        })
    });
exports.default = SvgS2ChevronSize400;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ekc37":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Like useEffect, but only called for updates after the initial render.
parcelHelpers.export(exports, "useUpdateEffect", ()=>useUpdateEffect);
var _react = require("react");
var _useEffectEvent = require("./useEffectEvent");
function useUpdateEffect(cb, dependencies) {
    const isInitialMount = (0, _react.useRef)(true);
    const lastDeps = (0, _react.useRef)(null);
    let cbEvent = (0, _useEffectEvent.useEffectEvent)(cb);
    (0, _react.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, _react.useEffect)(()=>{
        let prevDeps = lastDeps.current;
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!prevDeps || dependencies.some((dep, i)=>!Object.is(dep, prevDeps[i]))) cbEvent();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

},{"react":"a1TxN","./useEffectEvent":"eg4dC","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c6gMj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for list-like components with single selection.
 * Handles building a collection of items from props, and manages selection state.
 */ parcelHelpers.export(exports, "useSingleSelectListState", ()=>useSingleSelectListState);
var _useListState = require("./useListState");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useSingleSelectListState(props) {
    let [selectedKey, setSelectedKey] = (0, _utils.useControlledState)(props.selectedKey, props.defaultSelectedKey ?? null, props.onSelectionChange);
    let selectedKeys = (0, _react.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection, disabledKeys, selectionManager } = (0, _useListState.useListState)({
        ...props,
        selectionMode: 'single',
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys,
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            let key = keys.values().next().value ?? null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection,
        disabledKeys,
        selectionManager,
        selectedKey,
        setSelectedKey,
        selectedItem
    };
}

},{"./useListState":"hjoHP","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1F0Yz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuContext", ()=>MenuContext);
parcelHelpers.export(exports, "menu", ()=>menu);
parcelHelpers.export(exports, "section", ()=>section);
parcelHelpers.export(exports, "sectionHeader", ()=>sectionHeader);
parcelHelpers.export(exports, "sectionHeading", ()=>sectionHeading);
parcelHelpers.export(exports, "menuitem", ()=>menuitem);
parcelHelpers.export(exports, "checkmark", ()=>checkmark);
parcelHelpers.export(exports, "checkbox", ()=>checkbox);
parcelHelpers.export(exports, "icon", ()=>icon);
parcelHelpers.export(exports, "iconCenterWrapper", ()=>iconCenterWrapper);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "description", ()=>description);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "Divider", ()=>Divider);
parcelHelpers.export(exports, "MenuSection", ()=>MenuSection);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "MenuTrigger", ()=>MenuTrigger);
parcelHelpers.export(exports, "SubmenuTrigger", ()=>SubmenuTrigger);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "CombinedMenu", ()=>CombinedMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _centerBaseline = require("./CenterBaseline");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _react = require("react");
var _divider = require("./Divider");
var _content = require("./Content");
var _icon = require("./Icon"); // chevron right removed??
var _image = require("./Image");
var _popover = require("./Popover");
var _linkOut = require("../ui-icons/LinkOut");
var _linkOutDefault = parcelHelpers.interopDefault(_linkOut);
var _runtime = require("../style/runtime");
var _reactAria = require("react-aria");
var _interactions = require("@react-aria/interactions");
var _pressScale = require("./pressScale");
var _utils = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const MenuContext = /*#__PURE__*/ (0, _react.createContext)(null);
const menuItemGrid = {
    size: {
        S: [
            "calc(1.5rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(1.5rem * 3 / 8)"
        ],
        M: [
            "calc(2rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(2rem * 3 / 8)"
        ],
        L: [
            "calc(2.5rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(2.5rem * 3 / 8)"
        ],
        XL: [
            "calc(3rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(3rem * 3 / 8)"
        ]
    }
};
let menu = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' _Le12';
    rules += ' se12';
    if (props.size === "XL") rules += ' Dk92HIe12';
    else if (props.size === "L") rules += ' DyaX9Fb12';
    else if (props.size === "M") rules += ' Deb5jcb12';
    else if (props.size === "S") rules += ' DGTLJAe12';
    rules += ' _oa12';
    rules += ' K40ub4c12';
    if (!width) rules += ' Za12';
    if (props.isPopover) rules += ' _Na12';
    if (props.isPopover) rules += ' Pa12';
    if (props.isPopover) {
        if (!maxWidth) rules += ' Lh12';
    }
    if (props.isPopover) rules += ' Tt12';
    if (props.isPopover) rules += ' Qt12';
    if (props.isPopover) rules += ' St12';
    if (props.isPopover) rules += ' Rt12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' __ya12';
    return rules;
};
let section = function anonymous(props) {
    let rules = " ";
    rules += ' z2mU12';
    rules += ' yzZKy12';
    rules += ' eb12';
    rules += ' se12';
    rules += ' CcAc39c12';
    if (props.size === "XL") rules += ' Dk92HIe12';
    else if (props.size === "L") rules += ' DyaX9Fb12';
    else if (props.size === "M") rules += ' Deb5jcb12';
    else if (props.size === "S") rules += ' DGTLJAe12';
    return rules;
};
let sectionHeader = function anonymous(props) {
    let rules = " ";
    rules += ' pt12';
    rules += ' z3mU12';
    rules += ' yAZKy12';
    rules += ' _oa12';
    rules += ' MAyFGYc12';
    rules += ' Tu7Fubd12';
    rules += ' Qu7Fubd12';
    if (props.size === "XL") rules += ' -M_-Mk12';
    else if (props.size === "L") rules += ' -M_-Mh12';
    else if (props.size === "S") rules += ' -M_-Mg12';
    else if (props.size === "XS") rules += ' -M_-Mf12';
    else rules += ' -M_-Mi12';
    return rules;
};
let sectionHeading = " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-c12 vx12 xd12 _xa12 xX0cczbc12 _xX0cczba12 _Fd12 _FnuYUweb12 pt12 Jy12 Gy12 Iy12 Hy12";
let menuitem = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let gridColumnStart = false;
    let gridColumnEnd = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "z") gridColumnStart = true;
        if (p[1] === "y") gridColumnEnd = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) {
        rules += ' pp12';
        rules += ' plc12';
    } else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' se12';
    rules += ' ea12';
    rules += ' egLWx3bb12';
    rules += ' _oa12';
    rules += ' Sd12';
    rules += ' Rd12';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl12';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj12';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf12';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne12';
    } else if (!minWidth) rules += ' Nk12';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-ob12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' qh12';
    rules += ' -Qg41Lb-IAxCW0c12';
    rules += ' -Qg41Lb-gLWx3bIy12';
    rules += ' MAyFGYc12';
    rules += ' Td12';
    rules += ' QAzEcG12';
    rules += ' -aRvJDd-Tu7Fubd12';
    if (props.isFocused) rules += ' gF12';
    else rules += ' g912';
    if (!position) rules += ' _Pc12';
    if (!gridColumnStart) rules += ' z2mU12';
    if (!gridColumnEnd) rules += ' yzZKy12';
    rules += ' CcAc39c12';
    rules += ' DLwlgod12';
    rules += ' EpvfBwb12';
    rules += ' EDNKd2dZQmDFe12';
    rules += ' UDNKd2dai5a012';
    rules += ' FF12';
    rules += ' _Xa12';
    if (props.isLink) rules += ' ry12';
    else rules += ' ri12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.size === "XL") rules += ' -M_-Mk12';
    else if (props.size === "L") rules += ' -M_-Mh12';
    else if (props.size === "S") rules += ' -M_-Mg12';
    else if (props.size === "XS") rules += ' -M_-Mf12';
    else rules += ' -M_-Mi12';
    return rules;
};
let checkmark = function anonymous(props) {
    let rules = " ";
    if (props.isSelected) rules += ' _6c12';
    else rules += ' _6b12';
    rules += ' z2CW8rb12';
    rules += ' y2CW8rb12';
    rules += ' B2CW8rb12';
    rules += ' A2CW8rb12';
    if (props.isPressed) rules += ' ps12';
    else if (props.isFocusVisible) rules += ' ps12';
    else if (props.isHovered) rules += ' ps12';
    else rules += ' pu12';
    rules += ' -_8sjo0b-t5ZbAob12';
    rules += ' -_8sjo0b-lta12';
    rules += ' Hw12';
    rules += ' fa12';
    return rules;
};
let checkbox = " z2CW8rb12 y2CW8rb12 B2CW8rb12 A2CW8rb12 Hw12";
let icon = " sb12 ZuUmpre12 FuUmpre12 Ht12 Hsu12 -_8sjo0b-t5ZbAob12";
let iconCenterWrapper = " sd12 z2U5Crc12 y2U5Crc12 B2U5Crc12 A2U5Crc12";
let image = function anonymous(props) {
    let rules = " ";
    rules += ' z2U5Crc12';
    rules += ' y2U5Crc12';
    rules += ' B2U5Crc12';
    rules += ' AvoofG12';
    rules += ' Ht12';
    rules += ' Hsu12';
    rules += ' Jt12';
    rules += ' _dc12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    if (props.size === "XL") rules += ' ZF12';
    else if (props.size === "L") rules += ' Zx12';
    else if (props.size === "M") rules += ' Zw12';
    else if (props.size === "S") rules += ' ZC12';
    else rules += ' Zw12';
    if (props.size === "XL") rules += ' Fz12';
    else if (props.size === "L") rules += ' Fw12';
    else if (props.size === "M") rules += ' Fv12';
    else if (props.size === "S") rules += ' Fx12';
    else rules += ' Fv12';
    rules += ' fa12';
    rules += ' _Ha12';
    return rules;
};
let label = function anonymous(props) {
    let rules = " ";
    rules += ' zv6x9r12';
    rules += ' yv6x9r12';
    rules += ' Bv6x9r12';
    rules += ' Av6x9r12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' xc12';
    rules += ' _xa12';
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    rules += ' p40ub4c12';
    rules += ' JAzEcG12';
    return rules;
};
let description = function anonymous(props) {
    let rules = " ";
    rules += ' z9u7zPc12';
    rules += ' y9u7zPc12';
    rules += ' B9u7zPc12';
    rules += ' A9u7zPc12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "M") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "M") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "M") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) rules += ' pp12';
    else if (props.isFocused) rules += ' pt12';
    else {
        if (props.isPressed) rules += ' pt12';
        else if (props.isFocusVisible) rules += ' pt12';
        else if (props.isHovered) rules += ' pt12';
        else rules += ' pv12';
    }
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    return rules;
};
let value = " z8bmXs12 y8bmXs12 B8bmXs12 A8bmXs12 Iv12";
let keyboard = function anonymous(props) {
    let rules = " ";
    rules += ' z45MTAd12';
    rules += ' y45MTAd12';
    rules += ' B45MTAd12';
    rules += ' A45MTAd12';
    rules += ' Iv12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    if (props.isDisabled) rules += ' pp12';
    else rules += ' pn12';
    if (props.isDisabled) rules += ' plc12';
    rules += ' _Wb12';
    rules += ' _3f12';
    return rules;
};
let descriptor = " z0cdLvd12 y0cdLvd12 B0cdLvd12 A0cdLvd12 Iv12 -_8sjo0b-t5ZbAob12";
let InternalMenuContext = /*#__PURE__*/ (0, _react.createContext)({
    size: 'M',
    isSubmenu: false,
    hideLinkOutIcon: false
});
let InternalMenuTriggerContext = /*#__PURE__*/ (0, _react.createContext)(null);
let wrappingDiv = " sd12 Za12 Fb12";
const Menu = /*#__PURE__*/ (0, _react.forwardRef)(function Menu(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, MenuContext);
    let { isSubmenu, size: ctxSize } = (0, _react.useContext)(InternalMenuContext);
    let { children, size = ctxSize, UNSAFE_style, UNSAFE_className, styles, hideLinkOutIcon = false } = props;
    let ctx = (0, _react.useContext)(InternalMenuTriggerContext);
    let inPopover = (0, _react.useContext)((0, _popover.InPopoverContext));
    let isPopover = (ctx || isSubmenu) && !inPopover;
    let content = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalMenuContext.Provider, {
        value: {
            size,
            isSubmenu: true,
            hideLinkOutIcon
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeaderContext),
                    {
                        styles: sectionHeader({
                            size
                        })
                    }
                ],
                [
                    (0, _content.HeadingContext),
                    {
                        // @ts-ignore
                        role: 'presentation',
                        styles: sectionHeading
                    }
                ],
                [
                    (0, _content.TextContext),
                    {
                        slots: {
                            'description': {
                                styles: description({
                                    size
                                })
                            }
                        }
                    }
                ],
                [
                    (0, _popover.InPopoverContext),
                    false
                ]
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Menu), {
                ...props,
                className: menu({
                    size,
                    isPopover
                }, isPopover ? null : styles),
                children: children
            })
        })
    });
    if (isPopover) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
        ref: ref,
        padding: "none",
        hideArrow: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: UNSAFE_style,
            className: (UNSAFE_className || '') + wrappingDiv,
            children: content
        })
    });
    return content;
});
function Divider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Separator), {
        ...props,
        className: (0, _runtime.mergeStyles)((0, _divider.divider)({
            size: 'M',
            orientation: 'horizontal',
            isStaticColor: false
        }), " se12 skk12 z3mU12 yAZKy12 JydxGIe12 GydxGIe12")
    });
}
function MenuSection(props) {
    // remember, context doesn't work if it's around Section nor inside
    let { size } = (0, _react.useContext)(InternalMenuContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuSection), {
                ...props,
                className: section({
                    size
                }),
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Divider, {})
        ]
    });
}
const checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const linkIconSize = {
    S: 'M',
    M: 'L',
    L: 'XL',
    XL: 'XL'
};
function MenuItem(props1) {
    let ref = (0, _react.useRef)(null);
    let isLink = props1.href != null;
    let isLinkOut = isLink && props1.target === '_blank';
    let { size, hideLinkOutIcon } = (0, _react.useContext)(InternalMenuContext);
    let textValue = props1.textValue || (typeof props1.children === 'string' ? props1.children : undefined);
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuItem), {
        ...props1,
        textValue: textValue,
        ref: ref,
        style: (0, _pressScale.pressScale)(ref, props1.UNSAFE_style),
        className: (renderProps)=>(props1.UNSAFE_className || '') + menuitem({
                ...renderProps,
                isFocused: renderProps.hasSubmenu && renderProps.isOpen || renderProps.isFocused,
                size,
                isLink
            }, props1.styles),
        children: (renderProps)=>{
            let { children } = props1;
            let checkboxRenderProps = {
                ...renderProps,
                size,
                isFocused: false,
                isFocusVisible: false,
                isIndeterminate: false,
                isReadOnly: false,
                isInvalid: false,
                isRequired: false
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _icon.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, _centerBaseline.centerBaseline)({
                                            slot: 'icon',
                                            styles: iconCenterWrapper
                                        }),
                                        styles: icon
                                    },
                                    descriptor: {
                                        render: (0, _centerBaseline.centerBaseline)({
                                            slot: 'descriptor',
                                            styles: descriptor
                                        })
                                    } // TODO: remove once we have default?
                                }
                            }
                        ],
                        [
                            (0, _content.TextContext),
                            {
                                slots: {
                                    [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                        styles: label({
                                            size
                                        })
                                    },
                                    label: {
                                        styles: label({
                                            size
                                        })
                                    },
                                    description: {
                                        styles: description({
                                            ...renderProps,
                                            size
                                        })
                                    },
                                    value: {
                                        styles: value
                                    }
                                }
                            }
                        ],
                        [
                            (0, _content.KeyboardContext),
                            {
                                styles: keyboard({
                                    size,
                                    isDisabled: renderProps.isDisabled
                                })
                            }
                        ],
                        [
                            (0, _image.ImageContext),
                            {
                                styles: image({
                                    size
                                })
                            }
                        ]
                    ],
                    children: [
                        renderProps.selectionMode === 'single' && !renderProps.hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                            size: checkmarkIconSize[size],
                            className: checkmark({
                                ...renderProps,
                                size
                            })
                        }),
                        renderProps.selectionMode === 'multiple' && !renderProps.hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _runtime.mergeStyles)(checkbox, (0, _checkbox.box)(checkboxRenderProps)),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                                size: size,
                                className: (0, _checkbox.iconStyles)
                            })
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            slot: "label",
                            children: children
                        }) : children,
                        isLinkOut && !hideLinkOutIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            slot: "descriptor",
                            className: descriptor,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOutDefault.default), {
                                size: linkIconSize[size],
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a12';
                                        rules += ' __Ha12';
                                    }
                                    return rules;
                                }({
                                    direction
                                })
                            })
                        }),
                        renderProps.hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            slot: "descriptor",
                            className: descriptor,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                size: size,
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a12';
                                        rules += ' __Ha12';
                                    }
                                    return rules;
                                }({
                                    direction
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */ function MenuTrigger(props) {
    // RAC sets isPressed via PressResponder when the menu is open.
    // We don't want press scaling to appear to get "stuck", so override this.
    // For mouse interactions, menus open on press start. When the popover underlay appears
    // it covers the trigger button, causing onPressEnd to fire immediately and no press scaling
    // to occur. We override this by listening for pointerup on the document ourselves.
    let [isPressed, setPressed] = (0, _react.useState)(false);
    let { addGlobalListener } = (0, _utils.useGlobalListeners)();
    let onPressStart = (e)=>{
        if (e.pointerType !== 'mouse') return;
        setPressed(true);
        addGlobalListener(document, 'pointerup', ()=>{
            setPressed(false);
        }, {
            once: true,
            capture: true
        });
    };
    let { align = 'start', direction = 'bottom', shouldFlip } = props;
    let placement;
    switch(direction){
        case 'left':
        case 'right':
        case 'start':
        case 'end':
            placement = `${direction} ${align === 'end' ? 'bottom' : 'top'}`;
            break;
        case 'bottom':
        case 'top':
        default:
            placement = `${direction} ${align}`;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalMenuTriggerContext.Provider, {
        value: {
            align: props.align,
            direction: props.direction,
            shouldFlip: props.shouldFlip
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverContext).Provider, {
            value: {
                hideArrow: true,
                offset: 8,
                crossOffset: 0,
                placement,
                shouldFlip
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuTrigger), {
                ...props,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interactions.PressResponder), {
                    onPressStart: onPressStart,
                    isPressed: isPressed,
                    children: props.children
                })
            })
        })
    });
}
function SubmenuTrigger(props) {
    // For submenus, the offset from the edge of the popover should be 10px.
    // Subtract 8px for the padding around the parent menu.
    // Offset by padding + border so that the first item in a submenu lines up with the parent menu item.
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.SubmenuTrigger), {
        ...props,
        children: [
            props.children[0],
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverContext).Provider, {
                value: {
                    hideArrow: true,
                    offset: -2,
                    crossOffset: -8,
                    placement: 'end top'
                },
                children: props.children[1]
            })
        ]
    });
}
function CombinedMenu(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
}

},{"0":"Zn8C6","1":"kAgAE","2":"jVf2n","3":"iK7HU","4":"jpqoM","5":"hw7QY","6":"hS9QF","7":"cpPaS","8":"kYLwQ","9":"68d15","10":"dT3bW","11":"9Vu9r","12":"JiJMa","13":"jIgt0","14":"1zEap","15":"8ZZrP","16":"beWqV","17":"kfJw6","18":"cocgA","react/jsx-runtime":"2Is6Z","react-aria-components":[["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["Menu","8JFUP"],["MenuItem","8JFUP"],["MenuSection","8JFUP"],["MenuTrigger","8JFUP"],["SubmenuTrigger","8JFUP"],["Separator","8A8dQ"]],"./Checkbox":"jdSVu","./CenterBaseline":"1vpL9","../ui-icons/Checkmark":"gK3Wp","../ui-icons/Chevron":"1904U","react":"a1TxN","./Divider":"kGk2u","./Content":"10r6w","./Icon":"jQAJE","./Image":"4LTiE","./Popover":"62puW","../ui-icons/LinkOut":"6y2C0","../style/runtime":"8g9no","react-aria":"4k4z8","@react-aria/interactions":"bmg7W","./pressScale":"8Ufux","@react-aria/utils":"ceyTG","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Zn8C6":[function() {},{}],"kAgAE":[function() {},{}],"jVf2n":[function() {},{}],"iK7HU":[function() {},{}],"jpqoM":[function() {},{}],"hw7QY":[function() {},{}],"hS9QF":[function() {},{}],"cpPaS":[function() {},{}],"kYLwQ":[function() {},{}],"68d15":[function() {},{}],"dT3bW":[function() {},{}],"9Vu9r":[function() {},{}],"JiJMa":[function() {},{}],"jIgt0":[function() {},{}],"1zEap":[function() {},{}],"8ZZrP":[function() {},{}],"beWqV":[function() {},{}],"kfJw6":[function() {},{}],"cocgA":[function() {},{}],"jdSVu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxContext", ()=>CheckboxContext);
parcelHelpers.export(exports, "box", ()=>box);
parcelHelpers.export(exports, "iconStyles", ()=>iconStyles);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _react = require("react");
var _dash = require("../ui-icons/Dash");
var _dashDefault = parcelHelpers.interopDefault(_dash);
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CheckboxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let gridColumnStart = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "z") gridColumnStart = true;
        rules += p[0];
    }
    rules += ' sd12';
    if (!position) rules += ' _Pc12';
    rules += ' qf12';
    rules += ' ea12';
    if (!width) rules += ' ZJ12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) {
        rules += ' pp12';
        rules += ' plc12';
    } else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' Yc12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isInForm) {
        if (!gridColumnStart) rules += ' zhJUGr12';
    }
    rules += ' __ca12';
    return rules;
};
const box = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-oa12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    if (props.size === "XL") rules += ' Zm12';
    else if (props.size === "L") rules += ' Zl12';
    else if (props.size === "S") rules += ' Zk12';
    else rules += ' Zu12';
    if (props.size === "XL") rules += ' Fn12';
    else if (props.size === "L") rules += ' Fm12';
    else if (props.size === "S") rules += ' Fl12';
    else rules += ' Ft12';
    rules += ' _va12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' _Ca12';
    rules += ' _k7m7Gv12';
    rules += ' h7m7Gv12';
    rules += ' m7m7Gv12';
    rules += ' l7m7Gv12';
    rules += ' _oa12';
    rules += ' _jf12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _yb12';
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' gw12';
            rules += ' gld12';
        } else if (props.isInvalid) {
            if (props.isPressed) rules += ' gt12';
            else if (props.isFocusVisible) rules += ' gt12';
            else if (props.isHovered) rules += ' gt12';
            else rules += ' g_d12';
            rules += ' gl_b12';
        } else {
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' gY12';
                else if (props.isFocusVisible) rules += ' gY12';
                else if (props.isHovered) rules += ' gY12';
                else rules += ' g312';
            } else {
                if (props.isPressed) rules += ' gu12';
                else if (props.isFocusVisible) rules += ' gu12';
                else if (props.isHovered) rules += ' gu12';
                else rules += ' g012';
            }
            rules += ' gle12';
        }
    } else {
        rules += ' gX12';
        rules += ' gla12';
    }
    if (props.isSelected) rules += ' iA12';
    else if (props.isDisabled) {
        rules += ' io12';
        rules += ' ilc12';
    } else if (props.isInvalid) {
        if (props.isPressed) rules += ' im12';
        else if (props.isFocusVisible) rules += ' im12';
        else if (props.isHovered) rules += ' im12';
        else rules += ' ip12';
        rules += ' ile12';
    } else {
        if (props.isPressed) rules += ' in12';
        else if (props.isFocusVisible) rules += ' in12';
        else if (props.isHovered) rules += ' in12';
        else rules += ' iv12';
        rules += ' ila12';
    }
    return rules;
};
const iconStyles = " -_8sjo0b-txpP0Sb12 -_8sjo0b-lt8pvGJ12";
const iconSize = {
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(function Checkbox({ children, ...props }, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CheckboxContext);
    let boxRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let isInForm = !!(0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let isInCheckboxGroup = !!(0, _react.useContext)((0, _reactAriaComponents.CheckboxGroupStateContext));
    let ctx = (0, _reactAriaComponents.useSlottedContext)(CheckboxContext, props.slot);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        ref: domRef,
        inputRef: inputRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + wrapper({
                ...renderProps,
                isInForm,
                size: props.size || 'M'
            }, props.styles),
        children: (renderProps)=>{
            let checkbox = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: boxRef,
                style: (0, _pressScale.pressScale)(boxRef)(renderProps),
                className: box({
                    ...renderProps,
                    isSelected: renderProps.isSelected || renderProps.isIndeterminate,
                    size: props.size || 'M',
                    isEmphasized: isInCheckboxGroup ? ctx?.isEmphasized : props.isEmphasized
                }),
                children: [
                    renderProps.isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashDefault.default), {
                        size: iconSize[props.size || 'M'],
                        className: iconStyles
                    }),
                    renderProps.isSelected && !renderProps.isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                        size: iconSize[props.size || 'M'],
                        className: iconStyles
                    })
                ]
            });
            // Only render checkbox without center baseline if no label.
            // This avoids expanding the checkbox height to the font's line height.
            if (!children) return checkbox;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: checkbox
                    }),
                    children
                ]
            });
        }
    });
});

},{"0":"2ACec","1":"aVv7Y","2":"8l4lF","react/jsx-runtime":"2Is6Z","react-aria-components":[["Checkbox","9jC2J"],["CheckboxGroupStateContext","9jC2J"],["useSlottedContext","bA6Cz"]],"./CenterBaseline":"1vpL9","../ui-icons/Checkmark":"gK3Wp","react":"a1TxN","../ui-icons/Dash":"NC9AJ","./Form":"cHqN4","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2ACec":[function() {},{}],"aVv7Y":[function() {},{}],"8l4lF":[function() {},{}],"9jC2J":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>CheckboxGroupContext);
parcelHelpers.export(exports, "CheckboxGroupStateContext", ()=>CheckboxGroupStateContext);
parcelHelpers.export(exports, "CheckboxGroup", ()=>CheckboxGroup);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _reactAria = require("react-aria");
var _rspcontexts = require("./RSPContexts");
var _reactStately = require("react-stately");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const CheckboxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CheckboxGroupStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CheckboxGroup = /*#__PURE__*/ (0, _react.forwardRef)(function CheckboxGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, CheckboxGroupContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, _reactStately.useCheckboxGroupState)({
        ...props,
        validationBehavior
    });
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps, labelProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useCheckboxGroup)({
        ...props,
        label,
        validationBehavior
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false,
            isInvalid: state.isInvalid,
            state
        },
        defaultClassName: 'react-aria-CheckboxGroup'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                CheckboxGroupStateContext,
                state
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});
const Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(function Checkbox(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, _utils.useContextProps)(otherProps, ref, (0, _rspcontexts.CheckboxContext));
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let groupState = (0, _react.useContext)(CheckboxGroupStateContext);
    let inputRef = (0, _utils1.useObjectRef)((0, _react.useMemo)(()=>(0, _utils1.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let { labelProps, inputProps, isSelected, isDisabled, isReadOnly, isPressed, isInvalid } = groupState ? (0, _reactAria.useCheckboxGroupItem)({
        ...(0, _utils.removeDataAttributes)(props),
        // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
        // it's passed explicitly here to avoid typescript error (requires ignore).
        // @ts-ignore
        value: props.value,
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, groupState, inputRef) : (0, _reactAria.useCheckbox)({
        ...(0, _utils.removeDataAttributes)(props),
        children: typeof props.children === 'function' ? true : props.children,
        validationBehavior
    }, (0, _reactStately.useToggleState)(props), inputRef);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let isInteractionDisabled = isDisabled || isReadOnly;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Checkbox',
        values: {
            isSelected,
            isIndeterminate: props.isIndeterminate || false,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly,
            isInvalid,
            isRequired: props.isRequired || false
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...(0, _reactAria.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-indeterminate": props.isIndeterminate || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), {
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _reactAria.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
});

},{"react-aria":[["mergeProps","aNvcY"],["useCheckbox","35155"],["useCheckboxGroup","9YY6V"],["useCheckboxGroupItem","iYQ4M"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["VisuallyHidden","7zrGr"]],"./RSPContexts":"lIerG","react-stately":[["useCheckboxGroupState","j734z"],["useToggleState","gqIeU"]],"./utils":"bA6Cz","./FieldError":"algyu","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeRefs","1vHgg"],["useObjectRef","laqO5"]],"./Form":"g7RKA","./Label":"fjKq6","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"35155":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a checkbox component.
 * Checkboxes allow users to select multiple items from a list of individual items, or
 * to mark one individual item as selected.
 * @param props - Props for the checkbox.
 * @param state - State for the checkbox, as returned by `useToggleState`.
 * @param inputRef - A ref for the HTML input element.
 */ parcelHelpers.export(exports, "useCheckbox", ()=>useCheckbox);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _form = require("@react-stately/form");
var _form1 = require("@react-aria/form");
var _interactions = require("@react-aria/interactions");
var _toggle = require("@react-aria/toggle");
function useCheckbox(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, _form.useFormValidationState)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid, validationErrors, validationDetails } = validationState.displayValidation;
    let { labelProps, inputProps, isSelected, isPressed, isDisabled, isReadOnly } = (0, _toggle.useToggle)({
        ...props,
        isInvalid
    }, state, inputRef);
    (0, _form1.useFormValidation)(props, validationState, inputRef);
    let { isIndeterminate, isRequired, validationBehavior = 'aria' } = props;
    (0, _react.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    // Reset validation state on label press for checkbox with a hidden input.
    let { pressProps } = (0, _interactions.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            // @ts-expect-error
            let { [(0, _form.privateValidationStateProp)]: groupValidationState } = props;
            let { commitValidation } = groupValidationState ? groupValidationState : validationState;
            commitValidation();
        }
    });
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, pressProps, (0, _react.useMemo)(()=>({
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: {
            ...inputProps,
            checked: isSelected,
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            required: isRequired && validationBehavior === 'native'
        },
        isSelected,
        isPressed,
        isDisabled,
        isReadOnly,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"react":"a1TxN","@react-aria/utils":"aNvcY","@react-stately/form":"icH0S","@react-aria/form":"dKOez","@react-aria/interactions":"ckRNv","@react-aria/toggle":"1FamP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1FamP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles interactions for toggle elements, e.g. Checkboxes and Switches.
 */ parcelHelpers.export(exports, "useToggle", ()=>useToggle);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
function useToggle(props, state, ref) {
    let { isDisabled = false, isReadOnly = false, value, name, form, children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, validationState = 'valid', isInvalid, onPressStart, onPressEnd, onPressChange, onPress, onPressUp, onClick } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        onPressStart,
        onPressEnd,
        onPressChange,
        onPress,
        onPressUp,
        onClick,
        isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, _interactions.usePress)({
        onPressStart,
        onPressEnd,
        onPressChange,
        onPressUp,
        onClick,
        onPress (e) {
            onPress?.(e);
            state.toggle();
            ref.current?.focus();
        },
        isDisabled: isDisabled || isReadOnly
    });
    let { focusableProps } = (0, _interactions.useFocusable)(props, ref);
    let interactions = (0, _utils.mergeProps)(pressProps, focusableProps);
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    (0, _utils.useFormReset)(ref, state.defaultSelected, state.setSelected);
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, _utils.mergeProps)(domProps, {
            'aria-invalid': isInvalid || validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value
            },
            name,
            form,
            type: 'checkbox',
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled,
        isReadOnly,
        isInvalid: isInvalid || validationState === 'invalid'
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useFormReset","dwBOx"]],"@react-aria/interactions":[["useFocusable","kCQqy"],["usePress","ckRNv"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9YY6V":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a checkbox group component.
 * Checkbox groups allow users to select multiple items from a list of options.
 * @param props - Props for the checkbox group.
 * @param state - State for the checkbox group, as returned by `useCheckboxGroupState`.
 */ parcelHelpers.export(exports, "useCheckboxGroup", ()=>useCheckboxGroup);
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
function useCheckboxGroup(props, state) {
    let { isDisabled, name, form, validationBehavior = 'aria' } = props;
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    (0, _utils.checkboxGroupData).set(state, {
        name,
        form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior
    });
    let domProps = (0, _utils1.filterDOMProps)(props, {
        labelable: true
    });
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    return {
        groupProps: (0, _utils1.mergeProps)(domProps, {
            role: 'group',
            'aria-disabled': isDisabled || undefined,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"./utils":"3kv6X","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"@react-aria/label":"9u3SM","@react-aria/interactions":"8bxuk","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3kv6X":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkboxGroupData", ()=>checkboxGroupData);
const checkboxGroupData = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iYQ4M":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a checkbox component contained within a checkbox group.
 * Checkbox groups allow users to select multiple items from a list of options.
 * @param props - Props for the checkbox.
 * @param state - State for the checkbox, as returned by `useCheckboxGroupState`.
 * @param inputRef - A ref for the HTML input element.
 */ parcelHelpers.export(exports, "useCheckboxGroupItem", ()=>useCheckboxGroupItem);
var _useCheckbox = require("./useCheckbox");
var _utils = require("./utils");
var _form = require("@react-stately/form");
var _react = require("react");
var _toggle = require("@react-stately/toggle");
function useCheckboxGroupItem(props, state, inputRef) {
    const toggleState = (0, _toggle.useToggleState)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        defaultSelected: state.defaultValue.includes(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { name, form, descriptionId, errorMessageId, validationBehavior } = (0, _utils.checkboxGroupData).get(state);
    validationBehavior = props.validationBehavior ?? validationBehavior;
    // Local validation for this checkbox.
    let { realtimeValidation } = (0, _form.useFormValidationState)({
        ...props,
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: 'aria'
    });
    // Update the checkbox group state when realtime validation changes.
    let nativeValidation = (0, _react.useRef)((0, _form.DEFAULT_VALIDATION_RESULT));
    let updateValidation = ()=>{
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, _react.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    let displayValidation = validationBehavior === 'native' ? state.displayValidation : combinedRealtimeValidation;
    let res = (0, _useCheckbox.useCheckbox)({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        form: props.form || form,
        isRequired: props.isRequired ?? state.isRequired,
        validationBehavior,
        [(0, _form.privateValidationStateProp)]: {
            realtimeValidation: combinedRealtimeValidation,
            displayValidation,
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation,
            updateValidation (v) {
                nativeValidation.current = v;
                updateValidation();
            }
        }
    }, toggleState, inputRef);
    return {
        ...res,
        inputProps: {
            ...res.inputProps,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }
    };
}

},{"./useCheckbox":"35155","./utils":"3kv6X","@react-stately/form":"icH0S","react":"a1TxN","@react-stately/toggle":"gqIeU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gqIeU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for toggle components like checkboxes and switches.
 */ parcelHelpers.export(exports, "useToggleState", ()=>useToggleState);
var _utils = require("@react-stately/utils");
var _react = require("react");
function useToggleState(props = {}) {
    let { isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, _utils.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange);
    let [initialValue] = (0, _react.useState)(isSelected);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected,
        defaultSelected: props.defaultSelected ?? initialValue,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

},{"@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j734z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a checkbox group component. Provides a name for the group,
 * and manages selection and focus state.
 */ parcelHelpers.export(exports, "useCheckboxGroupState", ()=>useCheckboxGroupState);
var _form = require("@react-stately/form");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useCheckboxGroupState(props = {}) {
    let [selectedValues, setValue] = (0, _utils.useControlledState)(props.value, props.defaultValue || [], props.onChange);
    let [initialValues] = (0, _react.useState)(selectedValues);
    let isRequired = !!props.isRequired && selectedValues.length === 0;
    let invalidValues = (0, _react.useRef)(new Map());
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: selectedValues
    });
    let isInvalid = validation.displayValidation.isInvalid;
    const state = {
        ...validation,
        value: selectedValues,
        defaultValue: props.defaultValue ?? initialValues,
        setValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected (value) {
            return selectedValues.includes(value);
        },
        addValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue((selectedValues)=>{
                if (!selectedValues.includes(value)) return selectedValues.concat(value);
                return selectedValues;
            });
        },
        removeValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
        },
        toggleValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
            else setValue(selectedValues.concat(value));
        },
        setInvalid (value, v) {
            let s = new Map(invalidValues.current);
            if (v.isInvalid) s.set(value, v);
            else s.delete(value);
            invalidValues.current = s;
            validation.updateValidation((0, _form.mergeValidation)(...s.values()));
        },
        validationState: props.validationState ?? (isInvalid ? 'invalid' : null),
        isInvalid,
        isRequired
    };
    return state;
}

},{"@react-stately/form":"icH0S","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gK3Wp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Checkmark);
var _jsxRuntime = require("react/jsx-runtime");
var _s2CheckmarkSize200Svg = require("./S2_CheckmarkSize200.svg");
var _s2CheckmarkSize200SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize200Svg);
var _s2CheckmarkSize100Svg = require("./S2_CheckmarkSize100.svg");
var _s2CheckmarkSize100SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize100Svg);
var _s2CheckmarkSize75Svg = require("./S2_CheckmarkSize75.svg");
var _s2CheckmarkSize75SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize75Svg);
var _s2CheckmarkSize300Svg = require("./S2_CheckmarkSize300.svg");
var _s2CheckmarkSize300SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize300Svg);
var _s2CheckmarkSize50Svg = require("./S2_CheckmarkSize50.svg");
var _s2CheckmarkSize50SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize50Svg);
var _s2CheckmarkSize400Svg = require("./S2_CheckmarkSize400.svg");
var _s2CheckmarkSize400SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize400Svg);
let styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zi12';
    else if (props.size === "XS") rules += ' Zi12';
    else if (props.size === "XXL") rules += ' Zu12';
    else if (props.size === "XL") rules += ' Zk12';
    else if (props.size === "L") rules += ' Zj12';
    else if (props.size === "M") rules += ' Zi12';
    if (props.size === "S") rules += ' Fj12';
    else if (props.size === "XS") rules += ' Fj12';
    else if (props.size === "XXL") rules += ' Ft12';
    else if (props.size === "XL") rules += ' Fl12';
    else if (props.size === "L") rules += ' Fk12';
    else if (props.size === "M") rules += ' Fj12';
    return rules;
};
function Checkmark(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize100SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize200SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize300SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize400SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize50SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize75SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
    }
}

},{"0":"l3obK","react/jsx-runtime":"2Is6Z","./S2_CheckmarkSize200.svg":"9GyDh","./S2_CheckmarkSize100.svg":"2sAPt","./S2_CheckmarkSize75.svg":"i0RY8","./S2_CheckmarkSize300.svg":"dvUR7","./S2_CheckmarkSize50.svg":"hR9ud","./S2_CheckmarkSize400.svg":"ddr1i","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l3obK":[function() {},{}],"9GyDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M4.313 10.98c-.308 0-.602-.137-.8-.375L.648 7.165a1.042 1.042 0 0 1 1.6-1.334L4.29 8.283l5.442-6.93a1.043 1.043 0 0 1 1.64 1.288l-6.24 7.941a1.04 1.04 0 0 1-.804.397z"
        })
    });
exports.default = SvgS2CheckmarkSize200;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2sAPt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.5 9.503c-.3 0-.584-.135-.774-.367l-2.45-3A1 1 0 1 1 1.823 4.87L3.481 6.9 8.161.888A1 1 0 0 1 9.74 2.118l-5.45 7a1 1 0 0 1-.777.385z"
        })
    });
exports.default = SvgS2CheckmarkSize100;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i0RY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.667 9.074a.96.96 0 0 1-.737-.345L.753 6.116a.96.96 0 1 1 1.474-1.228l1.418 1.7 4.112-5.233a.96.96 0 1 1 1.51 1.186L4.422 8.707a.96.96 0 0 1-.741.367z"
        })
    });
exports.default = SvgS2CheckmarkSize75;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dvUR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M5.102 12.517c-.322 0-.627-.143-.833-.391L.989 8.191a1.083 1.083 0 0 1 .139-1.527 1.08 1.08 0 0 1 1.527.139l2.422 2.904 6.243-7.946a1.086 1.086 0 0 1 1.707 1.34l-7.072 9c-.203.258-.51.41-.838.416z"
        })
    });
exports.default = SvgS2CheckmarkSize300;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hR9ud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.815 8.69a.92.92 0 0 1-.708-.333L1.216 6.09a.922.922 0 0 1 1.416-1.18l1.162 1.394 3.56-4.532a.92.92 0 1 1 1.45 1.14L4.54 8.336a.92.92 0 0 1-.712.352z"
        })
    });
exports.default = SvgS2CheckmarkSize50;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ddr1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M5.864 14.115c-.335 0-.653-.15-.868-.407L1.25 9.21a1.13 1.13 0 1 1 1.736-1.447l2.854 3.424 7.148-9.1a1.13 1.13 0 1 1 1.777 1.396l-8.011 10.2a1.13 1.13 0 0 1-.872.432z"
        })
    });
exports.default = SvgS2CheckmarkSize400;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"NC9AJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dash);
var _jsxRuntime = require("react/jsx-runtime");
var _s2DashSize200Svg = require("./S2_DashSize200.svg");
var _s2DashSize200SvgDefault = parcelHelpers.interopDefault(_s2DashSize200Svg);
var _s2DashSize100Svg = require("./S2_DashSize100.svg");
var _s2DashSize100SvgDefault = parcelHelpers.interopDefault(_s2DashSize100Svg);
var _s2DashSize75Svg = require("./S2_DashSize75.svg");
var _s2DashSize75SvgDefault = parcelHelpers.interopDefault(_s2DashSize75Svg);
var _s2DashSize300Svg = require("./S2_DashSize300.svg");
var _s2DashSize300SvgDefault = parcelHelpers.interopDefault(_s2DashSize300Svg);
var _s2DashSize50Svg = require("./S2_DashSize50.svg");
var _s2DashSize50SvgDefault = parcelHelpers.interopDefault(_s2DashSize50Svg);
let styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zh12';
    else if (props.size === "XS") rules += ' Zh12';
    else if (props.size === "XL") rules += ' Zj12';
    else if (props.size === "L") rules += ' Zj12';
    else if (props.size === "M") rules += ' Zi12';
    if (props.size === "S") rules += ' Fi12';
    else if (props.size === "XS") rules += ' Fi12';
    else if (props.size === "XL") rules += ' Fk12';
    else if (props.size === "L") rules += ' Fk12';
    else if (props.size === "M") rules += ' Fj12';
    return rules;
};
function Dash(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize100SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize200SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize300SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize50SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize75SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
    }
}

},{"0":"hBG4M","react/jsx-runtime":"2Is6Z","./S2_DashSize200.svg":"4kt5k","./S2_DashSize100.svg":"4CuWo","./S2_DashSize75.svg":"hw3DQ","./S2_DashSize300.svg":"kZQRX","./S2_DashSize50.svg":"9UtvX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hBG4M":[function() {},{}],"4kt5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.021 7.041H1.98a1.04 1.04 0 1 1 0-2.082h8.042a1.04 1.04 0 1 1 0 2.082"
        })
    });
exports.default = SvgS2DashSize200;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4CuWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.5 6h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2"
        })
    });
exports.default = SvgS2DashSize100;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hw3DQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.99 4.96H1.01a.96.96 0 1 1 0-1.92h5.98a.96.96 0 1 1 0 1.92"
        })
    });
exports.default = SvgS2DashSize75;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kZQRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.61 7.085H1.39a1.084 1.084 0 1 1 0-2.17h9.22a1.084 1.084 0 1 1 0 2.17"
        })
    });
exports.default = SvgS2DashSize300;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9UtvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.634 4.922H1.366a.922.922 0 0 1 0-1.844h5.268a.922.922 0 0 1 0 1.844"
        })
    });
exports.default = SvgS2DashSize50;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kGk2u":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DividerContext", ()=>DividerContext);
parcelHelpers.export(exports, "divider", ()=>divider);
parcelHelpers.export(exports, "Divider", ()=>Divider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DividerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const divider = function anonymous(props, overrides) {
    let rules = " ";
    let alignSelf = false;
    let marginTop = false;
    let marginBottom = false;
    let marginInlineStart = false;
    let marginInlineEnd = false;
    let flexGrow = false;
    let flexShrink = false;
    let width = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_d") alignSelf = true;
        if (p[1] === "J") marginTop = true;
        if (p[1] === "G") marginBottom = true;
        if (p[1] === "I") marginInlineStart = true;
        if (p[1] === "H") marginInlineEnd = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr12';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s12';
    if (!alignSelf) rules += ' _df12';
    if (props.isStaticColor) {
        if (props.size === "L") rules += ' gi12';
        else rules += ' gg12';
    } else if (props.size === "L") rules += ' g012';
    else rules += ' gF12';
    rules += ' gl_a12';
    rules += ' _je12';
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    if (!marginTop) rules += ' Jy12';
    if (!marginBottom) rules += ' Gy12';
    if (!marginInlineStart) rules += ' Iy12';
    if (!marginInlineEnd) rules += ' Hy12';
    if (!flexGrow) rules += ' _ua12';
    if (!flexShrink) rules += ' _va12';
    if (props.orientation === "horizontal") {
        if (props.size === "L") rules += ' FT4Nfn12';
        else if (props.size === "S") rules += ' FceNfn12';
        else rules += ' FLvNfn12';
    }
    if (props.orientation === "vertical") {
        if (props.size === "L") {
            if (!width) rules += ' ZT4Nfn12';
        } else if (props.size === "S") {
            if (!width) rules += ' ZceNfn12';
        } else if (!width) rules += ' ZLvNfn12';
    }
    return rules;
};
const Divider = /*#__PURE__*/ (0, _react.forwardRef)(function Divider(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DividerContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Separator), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + divider({
            size: props.size || 'M',
            orientation: props.orientation || 'horizontal',
            staticColor: props.staticColor,
            isStaticColor: !!props.staticColor
        }, props.styles)
    });
});

},{"0":"cE1RF","react/jsx-runtime":"2Is6Z","react-aria-components":"8A8dQ","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cE1RF":[function() {},{}],"6y2C0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LinkOut);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinkOutSize200Svg = require("./S2_LinkOutSize200.svg");
var _s2LinkOutSize200SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize200Svg);
var _s2LinkOutSize100Svg = require("./S2_LinkOutSize100.svg");
var _s2LinkOutSize100SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize100Svg);
var _s2LinkOutSize300Svg = require("./S2_LinkOutSize300.svg");
var _s2LinkOutSize300SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize300Svg);
var _s2LinkOutSize400Svg = require("./S2_LinkOutSize400.svg");
var _s2LinkOutSize400SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize400Svg);
let styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XXL") rules += ' Zu12';
    else if (props.size === "XL") rules += ' Zk12';
    else if (props.size === "L") rules += ' Zj12';
    else if (props.size === "M") rules += ' Zi12';
    if (props.size === "XXL") rules += ' Ft12';
    else if (props.size === "XL") rules += ' Fl12';
    else if (props.size === "L") rules += ' Fk12';
    else if (props.size === "M") rules += ' Fj12';
    return rules;
};
function LinkOut(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize100SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize200SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize300SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize400SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
    }
}

},{"0":"9K42m","react/jsx-runtime":"2Is6Z","./S2_LinkOutSize200.svg":"376MY","./S2_LinkOutSize100.svg":"7I6nh","./S2_LinkOutSize300.svg":"Lthxm","./S2_LinkOutSize400.svg":"gaW94","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9K42m":[function() {},{}],"376MY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.089 1h-5.51a.911.911 0 0 0 0 1.822h3.31L1.355 9.355a.91.91 0 1 0 1.29 1.29L9.178 4.11v3.31a.911.911 0 0 0 1.822 0v-5.51A.91.91 0 0 0 10.089 1"
        })
    });
exports.default = SvgS2LinkOutSize200;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7I6nh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.125 1H3.741a.875.875 0 1 0 0 1.75h2.27l-4.88 4.88a.88.88 0 0 0 0 1.24.873.873 0 0 0 1.238 0L7.25 3.987v2.27a.875.875 0 1 0 1.75 0V1.876A.875.875 0 0 0 8.125 1"
        })
    });
exports.default = SvgS2LinkOutSize100;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Lthxm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M12.05 1H5.164a.949.949 0 1 0 0 1.898h4.595l-8.18 8.18a.95.95 0 0 0 1.344 1.344l8.18-8.18v4.595a.949.949 0 1 0 1.898 0V1.949A.95.95 0 0 0 12.05 1"
        })
    });
exports.default = SvgS2LinkOutSize300;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gaW94":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M14.01 1h-8a.99.99 0 0 0 0 1.979h5.613L1.551 13.05a.988.988 0 1 0 1.398 1.398L13.021 4.377v5.612a.99.99 0 0 0 1.979 0v-8A.99.99 0 0 0 14.01 1"
        })
    });
exports.default = SvgS2LinkOutSize400;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9R0uF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToastQueue", ()=>SpectrumToastQueue);
/**
 * A ToastContainer renders the queued toasts in an application. It should be placed
 * at the root of the app.
 */ parcelHelpers.export(exports, "ToastContainer", ()=>ToastContainer);
// Exported locally for stories.
parcelHelpers.export(exports, "SpectrumToast", ()=>SpectrumToast);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _button = require("./Button");
var _centerBaseline = require("./CenterBaseline");
var _s2IconCheckmarkCircle20NSvg = require("../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg");
var _s2IconCheckmarkCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconCheckmarkCircle20NSvg);
var _s2IconChevronDown20NSvg = require("../s2wf-icons/S2_Icon_ChevronDown_20_N.svg");
var _s2IconChevronDown20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronDown20NSvg);
var _closeButton = require("./CloseButton");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _reactDom = require("react-dom");
var _reactAria = require("react-aria");
var _s2IconInfoCircle20NSvg = require("../s2wf-icons/S2_Icon_InfoCircle_20_N.svg");
var _s2IconInfoCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconInfoCircle20NSvg);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _toastModuleCss = require("./Toast.module.css");
var _toastModuleCssDefault = parcelHelpers.interopDefault(_toastModuleCss);
var _i18N = require("@react-aria/i18n");
var _utils1 = require("@react-spectrum/utils");
var _reactStately = require("react-stately");
function startViewTransition(fn, type) {
    if ('startViewTransition' in document) {
        // Safari doesn't support :active-view-transition-type() yet, so we fall back to a class on the html element.
        document.documentElement.classList.add((0, _toastModuleCssDefault.default)[type]);
        let viewTransition = document.startViewTransition(()=>(0, _reactDom.flushSync)(fn));
        viewTransition.ready.catch(()=>{});
        viewTransition.finished.then(()=>{
            document.documentElement.classList.remove((0, _toastModuleCssDefault.default)[type]);
        });
    } else fn();
}
// There is a single global toast queue instance for the whole app, initialized lazily.
let globalToastQueue = null;
function getGlobalToastQueue() {
    if (!globalToastQueue) globalToastQueue = new (0, _reactAriaComponents.UNSTABLE_ToastQueue)({
        maxVisibleToasts: Infinity,
        wrapUpdate (fn, action) {
            startViewTransition(fn, `toast-${action}`);
        }
    });
    return globalToastQueue;
}
function addToast(children, variant, options = {}) {
    let value = {
        children,
        variant,
        actionLabel: options.actionLabel,
        onAction: options.onAction,
        shouldCloseOnAction: options.shouldCloseOnAction,
        ...(0, _utils.filterDOMProps)(options)
    };
    // Minimum time of 5s from https://spectrum.adobe.com/page/toast/#Auto-dismissible
    // Actionable toasts cannot be auto dismissed. That would fail WCAG SC 2.2.1.
    // It is debatable whether non-actionable toasts would also fail.
    let timeout = options.timeout && !options.actionLabel ? Math.max(options.timeout, 5000) : undefined;
    let queue = getGlobalToastQueue();
    let key = queue.add(value, {
        timeout,
        onClose: options.onClose
    });
    return ()=>queue.close(key);
}
const SpectrumToastQueue = {
    /** Queues a neutral toast. */ neutral (children, options = {}) {
        return addToast(children, 'neutral', options);
    },
    /** Queues a positive toast. */ positive (children, options = {}) {
        return addToast(children, 'positive', options);
    },
    /** Queues a negative toast. */ negative (children, options = {}) {
        return addToast(children, 'negative', options);
    },
    /** Queues an informational toast. */ info (children, options = {}) {
        return addToast(children, 'info', options);
    }
};
const toastRegion = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' sd12';
    if (props.placement === "bottom") rules += ' _tb12';
    else if (props.placement === "top") rules += ' _ta12';
    rules += ' _Pb12';
    rules += ' _Ar12';
    rules += ' _zr12';
    rules += ' ZJ12';
    if (props.placement === "top") {
        if (props.isExpanded) rules += ' Wr12';
        else rules += ' Wu12';
    }
    if (props.placement === "bottom") {
        if (props.isExpanded) rules += ' _lr12';
        else rules += ' _lu12';
    }
    if (props.align === "end") rules += ' IM12';
    else if (props.align === "center") rules += ' IM12';
    else if (props.align === "start") rules += ' IC12';
    if (props.align === "end") rules += ' HC12';
    else if (props.align === "center") rules += ' HM12';
    else if (props.align === "start") rules += ' HM12';
    rules += ' _oa12';
    rules += ' Kb12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    return rules;
};
const toastList = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc12';
    rules += ' _ub12';
    rules += ' sd12';
    rules += ' Ue12';
    rules += ' qe12';
    if (props.placement === "bottom") rules += ' _tb12';
    else if (props.placement === "top") rules += ' _ta12';
    rules += ' _oa12';
    rules += ' Jy12';
    rules += ' Gy12';
    if (props.isExpanded) {
        if (props.placement === "bottom") rules += ' Tt12';
        else if (props.placement === "top") rules += ' Tf12';
    }
    if (props.isExpanded) {
        if (props.placement === "bottom") rules += ' Qf12';
        else if (props.placement === "top") rules += ' Qt12';
    }
    if (props.isExpanded) rules += ' St12';
    else rules += ' Sd12';
    if (props.isExpanded) rules += ' Rt12';
    else rules += ' Rd12';
    if (props.isExpanded) rules += ' Ic12';
    else rules += ' Iy12';
    if (props.isExpanded) rules += ' Hc12';
    else rules += ' Hy12';
    if (props.isExpanded) rules += ' _Na12';
    if (props.isExpanded) rules += ' Pa12';
    return rules;
};
const toastStyle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    if (props.isExpanded) rules += ' Ok12';
    else rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' sd12';
    rules += ' Ul12';
    rules += ' ql12';
    rules += ' Sf12';
    rules += ' Rt12';
    rules += ' Te12';
    rules += ' Qe12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    rules += ' Mj12';
    rules += ' -Zn3gsb-L0uB6Qb12';
    rules += ' LksArhc12';
    rules += ' _oa12';
    rules += ' _va12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    rules += ' px12';
    if (props.variant === "negative") rules += ' gB12';
    else if (props.variant === "positive") rules += ' g112';
    else if (props.variant === "info") rules += ' g212';
    else if (props.variant === "neutral") rules += ' g612';
    rules += ' -_8sjo0b-t5ZbAob12';
    if (props.isExpanded) rules += ' _nd12';
    else rules += ' _nLeasBb12';
    return rules;
};
const toastBody = function anonymous(props) {
    let rules = " ";
    if (props.isSingle) rules += ' sd12';
    else rules += ' se12';
    rules += ' D4w1sLc12';
    rules += ' CWLL0Xb12';
    rules += ' _ub12';
    rules += ' _wb12';
    rules += ' eb12';
    rules += ' qj12';
    rules += ' Ue12';
    return rules;
};
const toastContent = " sd12 Ue12 qe12 ea12 zk52g2d12 yk52g2d12 Bk52g2d12 Ak52g2d12 ri12 ZJ12 -nTSCV-LTAEPe12 __ZLTAEPe12 Na12";
const controls = function anonymous(props) {
    let rules = " ";
    rules += ' _pb12';
    if (props.isExpanded) rules += ' sd12';
    else rules += ' sk12';
    rules += ' _Cb12';
    rules += ' Ue12';
    rules += ' qe12';
    if (props.isExpanded) rules += ' _Ib12';
    else rules += ' _Ia12';
    return rules;
};
const ICONS = {
    info: (0, _s2IconInfoCircle20NSvgDefault.default),
    negative: (0, _s2IconAlertTriangle20NSvgDefault.default),
    positive: (0, _s2IconCheckmarkCircle20NSvgDefault.default)
};
const ToastContainerContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ToastContainer(props) {
    let { placement = 'bottom' } = props;
    let queue = getGlobalToastQueue();
    let align = 'center';
    [placement, align = 'center'] = placement.split(' ');
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let regionRef = (0, _react.useRef)(null);
    let state = (0, _reactStately.useOverlayTriggerState)({});
    let { isOpen: isExpanded, close, toggle } = state;
    let ctx = (0, _react.useMemo)(()=>({
            isExpanded,
            toggleExpanded () {
                if (!isExpanded && queue.visibleToasts.length <= 1) return;
                startViewTransition(()=>toggle(), isExpanded ? 'toast-collapse' : 'toast-expand');
            }
        }), [
        isExpanded,
        toggle,
        queue
    ]);
    // Set the state to collapsed whenever the queue is emptied.
    (0, _react.useEffect)(()=>{
        return queue.subscribe(()=>{
            if (queue.visibleToasts.length === 0 && isExpanded) close();
        });
    }, [
        queue,
        isExpanded,
        close
    ]);
    let collapse = ()=>{
        regionRef.current?.focus();
        ctx.toggleExpanded();
    };
    // Prevent scroll, aria hide outside, and contain focus when expanded, since we take over the whole screen.
    // Attach event handler to the ref since ToastRegion doesn't pass through onKeyDown.
    (0, _reactAria.useModalOverlay)({}, state, regionRef);
    (0, _utils.useEvent)(regionRef, 'keydown', isExpanded ? (e)=>{
        if (e.key === 'Escape') collapse();
    } : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_ToastRegion), {
        ...props,
        ref: regionRef,
        queue: queue,
        className: (renderProps)=>toastRegion({
                ...renderProps,
                placement,
                align,
                isExpanded
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.FocusScope), {
            contain: isExpanded,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ToastContainerContext.Provider, {
                value: ctx,
                children: [
                    isExpanded && // eslint-disable-next-line
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _toastModuleCssDefault.default)['toast-background'] + " _Pb12 Wr12 _lr12 _Ar12 _zr12 g812",
                        onClick: collapse
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpectrumToastList, {
                        placement: placement,
                        align: align
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _toastModuleCssDefault.default)['toast-controls'] + controls({
                            isExpanded
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                                size: "S",
                                onPress: ()=>queue.clear(),
                                // Default focus ring does not have enough contrast against gray background.
                                UNSAFE_style: {
                                    outlineColor: 'white'
                                },
                                children: stringFormatter.format('toast.clearAll')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                                size: "S",
                                onPress: collapse,
                                UNSAFE_style: {
                                    outlineColor: 'white'
                                },
                                children: stringFormatter.format('toast.collapse')
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function SpectrumToastList({ placement, align }) {
    let { isExpanded, toggleExpanded } = (0, _react.useContext)(ToastContainerContext);
    // Attach click handler to ref since ToastList doesn't pass through onClick/onPress.
    let toastListRef = (0, _react.useRef)(null);
    (0, _utils.useEvent)(toastListRef, 'click', (e)=>{
        // Have to check if this is a button because stopPropagation in react events doesn't affect native events.
        if (!isExpanded && !e.target?.closest('button')) toggleExpanded();
    });
    let reduceMotion = (0, _utils1.useMediaQuery)('(prefers-reduced-motion)');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_ToastList), {
        ref: toastListRef,
        style: ({ isHovered })=>{
            let origin = isHovered ? 95 : 55;
            return {
                perspective: 80,
                perspectiveOrigin: 'center ' + (placement === 'top' ? `calc(100% + ${origin}px)` : `${-origin}px`),
                transition: 'perspective-origin 400ms'
            };
        },
        className: (0, _toastModuleCssDefault.default)[isExpanded ? 'toast-list-expanded' : 'toast-list-collapsed'] + toastList({
            placement,
            align,
            isExpanded
        }),
        children: ({ toast })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SpectrumToast, {
                toast: toast,
                placement: placement,
                align: align,
                reduceMotion: reduceMotion
            })
    });
}
function SpectrumToast(props) {
    let { toast, placement = 'bottom', align = 'center' } = props;
    let variant = toast.content.variant || 'info';
    let Icon = ICONS[variant];
    let state = (0, _react.useContext)((0, _reactAriaComponents.UNSTABLE_ToastStateContext));
    let visibleToasts = state.visibleToasts;
    let index = visibleToasts.indexOf(toast);
    let isMain = index <= 0;
    let ctx = (0, _react.useContext)(ToastContainerContext);
    let isExpanded = ctx?.isExpanded || false;
    let toastRef = (0, _react.useRef)(null);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // When not expanded, use a presentational div for the toasts behind the top one.
    // The content is invisible, all we show is the background color.
    if (!isMain && ctx && !ctx.isExpanded) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "presentation",
        style: {
            position: 'absolute',
            [placement === 'top' ? 'bottom' : 'top']: 0,
            left: 0,
            width: '100%',
            translate: `0 0 ${-12 * index / 16}rem`,
            // Only 3 toasts are visible in the stack at once, but all toasts are in the DOM.
            // This allows view transitions to smoothly animate them from where they would be
            // in the collapsed stack to their final position in the expanded list.
            opacity: index >= 3 ? 0 : 1,
            zIndex: visibleToasts.length - index - 1,
            // When reduced motion is enabled, use append index to view-transition-name
            // so that adding/removing a toast cross fades instead of transitioning the position.
            // This works because the toasts are seen as separate elements instead of the same one when their index changes.
            viewTransitionName: toast.key + (props.reduceMotion ? '-' + index : ''),
            viewTransitionClass: [
                (0, _toastModuleCssDefault.default).toast,
                (0, _toastModuleCssDefault.default)['background-toast']
            ].map((c)=>CSS.escape(c)).join(' ')
        },
        className: (0, _toastModuleCssDefault.default).toast + toastStyle({
            variant: toast.content.variant || 'info',
            index,
            isExpanded
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.UNSTABLE_Toast), {
        ref: toastRef,
        toast: toast,
        style: {
            zIndex: visibleToasts.length - index - 1,
            viewTransitionName: toast.key,
            viewTransitionClass: [
                (0, _toastModuleCssDefault.default).toast,
                !isMain ? (0, _toastModuleCssDefault.default)['background-toast'] : '',
                (0, _toastModuleCssDefault.default)[placement],
                (0, _toastModuleCssDefault.default)[align]
            ].filter(Boolean).map((c)=>CSS.escape(c)).join(' ')
        },
        className: (renderProps)=>(0, _toastModuleCssDefault.default).toast + toastStyle({
                ...renderProps,
                variant: toast.content.variant || 'info',
                index,
                isExpanded
            }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                role: "presentation",
                className: toastBody({
                    isSingle: !isMain || visibleToasts.length <= 1 || isExpanded
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.UNSTABLE_ToastContent), {
                        className: toastContent + (ctx && isMain ? ` ${(0, _toastModuleCssDefault.default)['toast-content']}` : null),
                        children: [
                            Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                slot: "title",
                                children: toast.content.children
                            })
                        ]
                    }),
                    !isExpanded && visibleToasts.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _actionButton.ActionButton), {
                        isQuiet: true,
                        staticColor: "white",
                        styles: " zPgKvMe12 yPgKvMe12 BPgKvMe12 APgKvMe12",
                        // Make the chevron line up with the toast text, even though there is padding within the button.
                        UNSAFE_style: {
                            marginInlineStart: variant === 'neutral' ? -10 : 14
                        },
                        UNSAFE_className: ctx && isMain ? (0, _toastModuleCssDefault.default)['toast-expand'] : undefined,
                        onPress: ()=>{
                            // This button disappears when clicked, so move focus to the toast.
                            toastRef.current?.focus();
                            ctx?.toggleExpanded();
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                children: stringFormatter.format('toast.showAll')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronDown20NSvgDefault.default), {
                                UNSAFE_style: {
                                    rotate: placement === 'bottom' ? '180deg' : undefined
                                }
                            })
                        ]
                    }),
                    toast.content.actionLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "secondary",
                        fillStyle: "outline",
                        staticColor: "white",
                        onPress: ()=>{
                            toast.content.onAction?.();
                            if (toast.content.shouldCloseOnAction) state.close(toast.key);
                        },
                        UNSAFE_className: ctx && isMain ? (0, _toastModuleCssDefault.default)['toast-action'] : undefined,
                        styles: " IM12 zzz3eAe12 yzz3eAe12 Bzz3eAe12 Azz3eAe12",
                        children: toast.content.actionLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                staticColor: "white",
                UNSAFE_className: ctx && isMain ? (0, _toastModuleCssDefault.default)['toast-close'] : undefined
            })
        ]
    });
}

},{"0":"eaqOT","1":"943B1","2":"e2Lko","3":"csnfN","4":"iG70u","5":"8SoyR","6":"fc8ZF","7":"6E4Bi","8":"580SI","react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"jyuVv","./Button":"gZHck","./CenterBaseline":"1vpL9","../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg":"6hpGX","../s2wf-icons/S2_Icon_ChevronDown_20_N.svg":"erT5A","./CloseButton":"8LP64","react":"a1TxN","@react-aria/utils":[["filterDOMProps","3upVm"],["useEvent","c8GoD"]],"react-dom":"gC2PC","react-aria":[["FocusScope","9oPIl"],["useModalOverlay","awkgj"]],"../s2wf-icons/S2_Icon_InfoCircle_20_N.svg":"hByEX","../intl/*.json":"gDH3q","react-aria-components":[["UNSTABLE_Toast","3OynU","Toast"],["UNSTABLE_ToastContent","3OynU","ToastContent"],["UNSTABLE_ToastList","3OynU","ToastList"],["UNSTABLE_ToastRegion","3OynU","ToastRegion"],["UNSTABLE_ToastStateContext","3OynU","ToastStateContext"],["UNSTABLE_ToastQueue","9o0L0","ToastQueue"]],"./Content":"10r6w","./Toast.module.css":"62rTY","@react-aria/i18n":"7lxyl","@react-spectrum/utils":"5Q3yF","react-stately":"1hSAS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eaqOT":[function() {},{}],"943B1":[function() {},{}],"e2Lko":[function() {},{}],"csnfN":[function() {},{}],"iG70u":[function() {},{}],"8SoyR":[function() {},{}],"fc8ZF":[function() {},{}],"6E4Bi":[function() {},{}],"580SI":[function() {},{}],"3OynU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToastStateContext", ()=>ToastStateContext);
parcelHelpers.export(exports, "ToastRegion", ()=>ToastRegion);
parcelHelpers.export(exports, "ToastList", ()=>ToastList);
parcelHelpers.export(exports, "Toast", ()=>Toast);
parcelHelpers.export(exports, "ToastContentContext", ()=>ToastContentContext);
parcelHelpers.export(exports, "ToastContent", ()=>ToastContent);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _reactDom = require("react-dom");
var _utils1 = require("@react-aria/utils");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _ssr = require("@react-aria/ssr");
var _overlays = require("@react-aria/overlays");
const ToastStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ToastRegion = /*#__PURE__*/ (0, _react.forwardRef)(function ToastRegion(props, ref) {
    let isSSR = (0, _ssr.useIsSSR)();
    let state = (0, _reactStately.useToastQueue)(props.queue);
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let { regionProps } = (0, _reactAria.useToastRegion)(props, state, objectRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({});
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ToastRegion',
        values: {
            visibleToasts: state.visibleToasts,
            isHovered,
            isFocused,
            isFocusVisible
        }
    });
    let { direction } = (0, _reactAria.useLocale)();
    let portalContainer;
    let { getContainer } = (0, _overlays.useUNSAFE_PortalContext)();
    if (!isSSR) {
        portalContainer = document.body;
        if (getContainer) portalContainer = getContainer();
    }
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    let region = /*#__PURE__*/ (0, _reactDefault.default).createElement(ToastStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, regionProps, focusProps, hoverProps),
        dir: direction,
        ref: objectRef,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, typeof props.children === 'function' ? /*#__PURE__*/ (0, _reactDefault.default).createElement(ToastList, {
        ...props,
        className: undefined,
        style: {
            display: 'contents'
        }
    }, props.children) : props.children));
    return state.visibleToasts.length > 0 && portalContainer ? /*#__PURE__*/ (0, _reactDom.createPortal)(region, portalContainer) : null;
});
const ToastList = /*#__PURE__*/ (0, _react.forwardRef)(function ToastList(props, ref) {
    let state = (0, _react.useContext)(ToastStateContext);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({});
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ToastList',
        values: {
            visibleToasts: state.visibleToasts,
            isFocused: false,
            isFocusVisible: false,
            isHovered
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ol", {
        ...hoverProps,
        ...renderProps,
        ref: ref
    }, state.visibleToasts.map((toast)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: toast.key,
            style: {
                display: 'contents'
            }
        }, props.children({
            toast
        }))));
});
const Toast = /*#__PURE__*/ (0, _react.forwardRef)(function Toast(props, ref) {
    let state = (0, _react.useContext)(ToastStateContext);
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let { toastProps, contentProps, titleProps, descriptionProps, closeButtonProps } = (0, _reactAria.useToast)(props, state, objectRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Toast',
        values: {
            toast: props.toast,
            isFocused,
            isFocusVisible
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, toastProps, focusProps),
        ref: objectRef,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ToastContentContext,
                contentProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        title: titleProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        close: closeButtonProps
                    }
                }
            ]
        ]
    }, renderProps.children));
});
const ToastContentContext = /*#__PURE__*/ (0, _react.createContext)({});
const ToastContent = /*#__PURE__*/ (0, _react.forwardRef)(function ToastContent(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ToastContentContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "react-aria-ToastContent",
        ...props,
        ref: ref
    }, props.children);
});

},{"react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useLocale","4k4z8"],["useToast","hFcAy"],["useToastRegion","9mfQj"]],"./Button":"9G5XO","./utils":"bA6Cz","react-dom":"gC2PC","@react-aria/utils":[["filterDOMProps","3upVm"],["useObjectRef","laqO5"]],"react-stately":"9o0L0","react":"a1TxN","./Text":"jt9fm","@react-aria/ssr":"ictJr","@react-aria/overlays":"8uUhJ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hFcAy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toast component.
 * Toasts display brief, temporary notifications of actions, errors, or other events in an application.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "useToast", ()=>useToast);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
function useToast(props, state, ref) {
    let { key, timer, timeout } = props.toast;
    (0, _react.useEffect)(()=>{
        if (timer == null || timeout == null) return;
        timer.reset(timeout);
        return ()=>{
            timer.pause();
        };
    }, [
        timer,
        timeout
    ]);
    let titleId = (0, _utils.useId)();
    let descriptionId = (0, _utils.useSlotId)();
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/toast');
    // This is required for NVDA announcements, without it NVDA will NOT announce the toast when it appears.
    // Originally was tied to animationStart/End via https://github.com/adobe/react-spectrum/pull/6223/commits/e22e319df64958e822ab7cd9685e96818cae9ba5
    // but toasts don't always have animations.
    let [isVisible, setIsVisible] = (0, _react.useState)(false);
    (0, _utils.useLayoutEffect)(()=>{
        setIsVisible(true);
    }, []);
    let toastProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    return {
        toastProps: {
            ...toastProps,
            role: 'alertdialog',
            'aria-modal': 'false',
            'aria-labelledby': props['aria-labelledby'] || titleId,
            'aria-describedby': props['aria-describedby'] || descriptionId,
            tabIndex: 0
        },
        contentProps: {
            role: 'alert',
            'aria-atomic': 'true',
            'aria-hidden': isVisible ? undefined : 'true'
        },
        titleProps: {
            id: titleId
        },
        descriptionProps: {
            id: descriptionId
        },
        closeButtonProps: {
            'aria-label': stringFormatter.format('close'),
            onPress: ()=>state.close(key)
        }
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["useId","jbI4Y"],["useSlotId","jbI4Y"],["useLayoutEffect","2ViQu"]],"../intl/*.json":"4d8qC","react":"a1TxN","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4d8qC":[function(require,module,exports,__globalThis) {
const _temp0 = require("a235226c8b0aa43f");
const _temp1 = require("fddd1fffd90138dc");
const _temp2 = require("4db25eb52b246676");
const _temp3 = require("8d4d96346d9a5df9");
const _temp4 = require("289d5835e3af1404");
const _temp5 = require("70f1daa5fd8409d6");
const _temp6 = require("7f4cffe4226e276c");
const _temp7 = require("e8b4ceff72672e8e");
const _temp8 = require("4efe71ce14603aee");
const _temp9 = require("fd35f814f0be145a");
const _temp10 = require("cd8f4f09f1becfac");
const _temp11 = require("39b37b04c6542844");
const _temp12 = require("2ead5c920f1cd0b1");
const _temp13 = require("c8eb7ed8cc71c6d3");
const _temp14 = require("c377d9a4790c23a4");
const _temp15 = require("280c14ce7f49927d");
const _temp16 = require("6baff32cda8c5e40");
const _temp17 = require("88218782d00e6662");
const _temp18 = require("2b9dc5243594df37");
const _temp19 = require("7177d5b4693fd394");
const _temp20 = require("2e862ab8860fa971");
const _temp21 = require("6b238e4dafdf4da7");
const _temp22 = require("a433daa12d943c12");
const _temp23 = require("a66c21477afabba0");
const _temp24 = require("8405e5b3353044db");
const _temp25 = require("dc5e8960d06e5e77");
const _temp26 = require("653494489899e692");
const _temp27 = require("290e1881314038e9");
const _temp28 = require("235aceeac94bc2c8");
const _temp29 = require("a2bd7a6f4a775b90");
const _temp30 = require("24f26bc2763b0ac5");
const _temp31 = require("b6e6aa64ef3ea06a");
const _temp32 = require("98b0b28b076dfc5b");
const _temp33 = require("1ef8938ba38447e9");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"a235226c8b0aa43f":"ctpKo","fddd1fffd90138dc":"ctpKo","4db25eb52b246676":"ctpKo","8d4d96346d9a5df9":"ctpKo","289d5835e3af1404":"ctpKo","70f1daa5fd8409d6":"ctpKo","7f4cffe4226e276c":"adSIt","e8b4ceff72672e8e":"ctpKo","4efe71ce14603aee":"ctpKo","fd35f814f0be145a":"ctpKo","cd8f4f09f1becfac":"ctpKo","39b37b04c6542844":"ctpKo","2ead5c920f1cd0b1":"ctpKo","c8eb7ed8cc71c6d3":"ctpKo","c377d9a4790c23a4":"ctpKo","280c14ce7f49927d":"ctpKo","6baff32cda8c5e40":"ctpKo","88218782d00e6662":"ctpKo","2b9dc5243594df37":"ctpKo","7177d5b4693fd394":"ctpKo","2e862ab8860fa971":"ctpKo","6b238e4dafdf4da7":"ctpKo","a433daa12d943c12":"ctpKo","a66c21477afabba0":"ctpKo","8405e5b3353044db":"ctpKo","dc5e8960d06e5e77":"ctpKo","653494489899e692":"ctpKo","290e1881314038e9":"ctpKo","235aceeac94bc2c8":"ctpKo","a2bd7a6f4a775b90":"ctpKo","24f26bc2763b0ac5":"ctpKo","b6e6aa64ef3ea06a":"ctpKo","98b0b28b076dfc5b":"ctpKo","1ef8938ba38447e9":"ctpKo"}],"adSIt":[function(require,module,exports,__globalThis) {
module.exports = {
    "close": `Close`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notification`,
            other: ()=>`${formatter.number(args.count)} notifications`
        })}.`
};

},{}],"9mfQj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toast region containing one or more toasts.
 * Toasts display brief, temporary notifications of actions, errors, or other events in an application.
 */ parcelHelpers.export(exports, "useToastRegion", ()=>useToastRegion);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _landmark = require("@react-aria/landmark");
var _i18N = require("@react-aria/i18n");
function useToastRegion(props, state, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/toast');
    let { landmarkProps } = (0, _landmark.useLandmark)({
        role: 'region',
        'aria-label': props['aria-label'] || stringFormatter.format('notifications', {
            count: state.visibleToasts.length
        })
    }, ref);
    let isHovered = (0, _react.useRef)(false);
    let isFocused = (0, _react.useRef)(false);
    let updateTimers = (0, _react.useCallback)(()=>{
        if (isHovered.current || isFocused.current) state.pauseAll();
        else state.resumeAll();
    }, [
        state
    ]);
    let { hoverProps } = (0, _interactions.useHover)({
        onHoverStart: ()=>{
            isHovered.current = true;
            updateTimers();
        },
        onHoverEnd: ()=>{
            isHovered.current = false;
            updateTimers();
        }
    });
    // Manage focus within the toast region.
    // If a focused containing toast is removed, move focus to the next toast, or the previous toast if there is no next toast.
    let toasts = (0, _react.useRef)([]);
    let prevVisibleToasts = (0, _react.useRef)(state.visibleToasts);
    let focusedToast = (0, _react.useRef)(null);
    (0, _utils.useLayoutEffect)(()=>{
        // If no toast has focus, then don't do anything.
        if (focusedToast.current === -1 || state.visibleToasts.length === 0 || !ref.current) {
            toasts.current = [];
            prevVisibleToasts.current = state.visibleToasts;
            return;
        }
        toasts.current = [
            ...ref.current.querySelectorAll('[role="alertdialog"]')
        ];
        // If the visible toasts haven't changed, we don't need to do anything.
        if (prevVisibleToasts.current.length === state.visibleToasts.length && state.visibleToasts.every((t, i)=>t.key === prevVisibleToasts.current[i].key)) {
            prevVisibleToasts.current = state.visibleToasts;
            return;
        }
        // Get a list of all toasts by index and add info if they are removed.
        let allToasts = prevVisibleToasts.current.map((t, i)=>({
                ...t,
                i,
                isRemoved: !state.visibleToasts.some((t2)=>t.key === t2.key)
            }));
        let removedFocusedToastIndex = allToasts.findIndex((t)=>t.i === focusedToast.current && t.isRemoved);
        // If the focused toast was removed, focus the next or previous toast.
        if (removedFocusedToastIndex > -1) {
            // In pointer modality, move focus out of the toast region.
            // Otherwise auto-dismiss timers will appear "stuck".
            if ((0, _interactions.getInteractionModality)() === 'pointer' && lastFocused.current?.isConnected) (0, _utils.focusWithoutScrolling)(lastFocused.current);
            else {
                let i = 0;
                let nextToast;
                let prevToast;
                while(i <= removedFocusedToastIndex){
                    if (!allToasts[i].isRemoved) prevToast = Math.max(0, i - 1);
                    i++;
                }
                while(i < allToasts.length){
                    if (!allToasts[i].isRemoved) {
                        nextToast = i - 1;
                        break;
                    }
                    i++;
                }
                // in the case where it's one toast at a time, both will be undefined, but we know the index must be 0
                if (prevToast === undefined && nextToast === undefined) prevToast = 0;
                // prioritize going to newer toasts
                if (prevToast >= 0 && prevToast < toasts.current.length) (0, _utils.focusWithoutScrolling)(toasts.current[prevToast]);
                else if (nextToast >= 0 && nextToast < toasts.current.length) (0, _utils.focusWithoutScrolling)(toasts.current[nextToast]);
            }
        }
        prevVisibleToasts.current = state.visibleToasts;
    }, [
        state.visibleToasts,
        ref
    ]);
    let lastFocused = (0, _react.useRef)(null);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithin: (e)=>{
            isFocused.current = true;
            lastFocused.current = e.relatedTarget;
            updateTimers();
        },
        onBlurWithin: ()=>{
            isFocused.current = false;
            lastFocused.current = null;
            updateTimers();
        }
    });
    // When the number of visible toasts becomes 0 or the region unmounts,
    // restore focus to the last element that had focus before the user moved focus
    // into the region. FocusScope restore focus doesn't update whenever the focus
    // moves in, it only happens once, so we correct it.
    // Because we're in a hook, we can't control if the user unmounts or not.
    (0, _react.useEffect)(()=>{
        if (state.visibleToasts.length === 0 && lastFocused.current?.isConnected) {
            if ((0, _interactions.getInteractionModality)() === 'pointer') (0, _utils.focusWithoutScrolling)(lastFocused.current);
            else lastFocused.current.focus();
            lastFocused.current = null;
        }
    }, [
        ref,
        state.visibleToasts.length
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (lastFocused.current?.isConnected) {
                if ((0, _interactions.getInteractionModality)() === 'pointer') (0, _utils.focusWithoutScrolling)(lastFocused.current);
                else lastFocused.current.focus();
                lastFocused.current = null;
            }
        };
    }, [
        ref
    ]);
    return {
        regionProps: (0, _utils.mergeProps)(landmarkProps, hoverProps, focusWithinProps, {
            tabIndex: -1,
            // Mark the toast region as a "top layer", so that it:
            //   - is not aria-hidden when opening an overlay
            //   - allows focus even outside a containing focus scope
            //   - doesn’t dismiss overlays when clicking on it, even though it is outside
            // @ts-ignore
            'data-react-aria-top-layer': true,
            // listen to focus events separate from focuswithin because that will only fire once
            // and we need to follow all focus changes
            onFocus: (e)=>{
                let target = e.target.closest('[role="alertdialog"]');
                focusedToast.current = toasts.current.findIndex((t)=>t === target);
            },
            onBlur: ()=>{
                focusedToast.current = -1;
            }
        })
    };
}

},{"@react-aria/utils":[["focusWithoutScrolling","81NOP"],["mergeProps","aNvcY"],["useLayoutEffect","2ViQu"]],"@react-aria/interactions":[["getInteractionModality","dkfxW"],["useFocusWithin","8bxuk"],["useHover","k6FLA"]],"../intl/*.json":"4d8qC","react":"a1TxN","@react-aria/landmark":"38wWs","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"38wWs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates a LandmarkController, which allows programmatic navigation of landmarks. */ parcelHelpers.export(exports, "UNSTABLE_createLandmarkController", ()=>UNSTABLE_createLandmarkController);
/**
 * Provides landmark navigation in an application. Call this with a role and label to register a landmark navigable with F6.
 * @param props - Props for the landmark.
 * @param ref - Ref to the landmark.
 */ parcelHelpers.export(exports, "useLandmark", ()=>useLandmark);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _indexJs = require("use-sync-external-store/shim/index.js");
// Increment this version number whenever the
// LandmarkManagerApi or Landmark interfaces change.
const LANDMARK_API_VERSION = 1;
// Symbol under which the singleton landmark manager instance is attached to the document.
const landmarkSymbol = Symbol.for('react-aria-landmark-manager');
function subscribe(fn) {
    document.addEventListener('react-aria-landmark-manager-change', fn);
    return ()=>document.removeEventListener('react-aria-landmark-manager-change', fn);
}
function getLandmarkManager() {
    if (typeof document === 'undefined') return null;
    // Reuse an existing instance if it has the same or greater version.
    let instance = document[landmarkSymbol];
    if (instance && instance.version >= LANDMARK_API_VERSION) return instance;
    // Otherwise, create a new instance and dispatch an event so anything using the existing
    // instance updates and re-registers their landmarks with the new one.
    document[landmarkSymbol] = new LandmarkManager();
    document.dispatchEvent(new CustomEvent('react-aria-landmark-manager-change'));
    return document[landmarkSymbol];
}
// Subscribes a React component to the current landmark manager instance.
function useLandmarkManager() {
    return (0, _indexJs.useSyncExternalStore)(subscribe, getLandmarkManager, getLandmarkManager);
}
class LandmarkManager {
    constructor(){
        this.landmarks = [];
        this.isListening = false;
        this.refCount = 0;
        this.version = LANDMARK_API_VERSION;
        this.f6Handler = this.f6Handler.bind(this);
        this.focusinHandler = this.focusinHandler.bind(this);
        this.focusoutHandler = this.focusoutHandler.bind(this);
    }
    setupIfNeeded() {
        if (this.isListening) return;
        document.addEventListener('keydown', this.f6Handler, {
            capture: true
        });
        document.addEventListener('focusin', this.focusinHandler, {
            capture: true
        });
        document.addEventListener('focusout', this.focusoutHandler, {
            capture: true
        });
        this.isListening = true;
    }
    teardownIfNeeded() {
        if (!this.isListening || this.landmarks.length > 0 || this.refCount > 0) return;
        document.removeEventListener('keydown', this.f6Handler, {
            capture: true
        });
        document.removeEventListener('focusin', this.focusinHandler, {
            capture: true
        });
        document.removeEventListener('focusout', this.focusoutHandler, {
            capture: true
        });
        this.isListening = false;
    }
    focusLandmark(landmark, direction) {
        this.landmarks.find((l)=>l.ref.current === landmark)?.focus?.(direction);
    }
    /**
   * Return set of landmarks with a specific role.
   */ getLandmarksByRole(role) {
        return new Set(this.landmarks.filter((l)=>l.role === role));
    }
    /**
   * Return first landmark with a specific role.
   */ getLandmarkByRole(role) {
        return this.landmarks.find((l)=>l.role === role);
    }
    addLandmark(newLandmark) {
        this.setupIfNeeded();
        if (this.landmarks.find((landmark)=>landmark.ref === newLandmark.ref) || !newLandmark.ref.current) return;
        this.landmarks.filter((landmark)=>landmark.role === 'main').length;
        if (this.landmarks.length === 0) {
            this.landmarks = [
                newLandmark
            ];
            this.checkLabels(newLandmark.role);
            return;
        }
        // Binary search to insert new landmark based on position in document relative to existing landmarks.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        let start = 0;
        let end = this.landmarks.length - 1;
        while(start <= end){
            let mid = Math.floor((start + end) / 2);
            let comparedPosition = newLandmark.ref.current.compareDocumentPosition(this.landmarks[mid].ref.current);
            let isNewAfterExisting = Boolean(comparedPosition & Node.DOCUMENT_POSITION_PRECEDING || comparedPosition & Node.DOCUMENT_POSITION_CONTAINS);
            if (isNewAfterExisting) start = mid + 1;
            else end = mid - 1;
        }
        this.landmarks.splice(start, 0, newLandmark);
        this.checkLabels(newLandmark.role);
    }
    updateLandmark(landmark) {
        let index = this.landmarks.findIndex((l)=>l.ref === landmark.ref);
        if (index >= 0) {
            this.landmarks[index] = {
                ...this.landmarks[index],
                ...landmark
            };
            this.checkLabels(this.landmarks[index].role);
        }
    }
    removeLandmark(ref) {
        this.landmarks = this.landmarks.filter((landmark)=>landmark.ref !== ref);
        this.teardownIfNeeded();
    }
    /**
   * Warn if there are 2+ landmarks with the same role but no label.
   * Labels for landmarks with the same role must also be unique.
   *
   * See https://www.w3.org/WAI/ARIA/apg/practices/landmark-regions/.
   */ checkLabels(role) {
        let landmarksWithRole = this.getLandmarksByRole(role);
        if (landmarksWithRole.size > 1) {
            let duplicatesWithoutLabel = [
                ...landmarksWithRole
            ].filter((landmark)=>!landmark.label);
            duplicatesWithoutLabel.length;
            var landmark;
            var label, landmark1, landmark2;
        }
    }
    /**
   * Get the landmark that is the closest parent in the DOM.
   * Returns undefined if no parent is a landmark.
   */ closestLandmark(element) {
        let landmarkMap = new Map(this.landmarks.map((l)=>[
                l.ref.current,
                l
            ]));
        let currentElement = element;
        while(currentElement && !landmarkMap.has(currentElement) && currentElement !== document.body && currentElement.parentElement)currentElement = currentElement.parentElement;
        return landmarkMap.get(currentElement);
    }
    /**
   * Gets the next landmark, in DOM focus order, or previous if backwards is specified.
   * If last landmark, next should be the first landmark.
   * If not inside a landmark, will return first landmark.
   * Returns undefined if there are no landmarks.
   */ getNextLandmark(element, { backward }) {
        let currentLandmark = this.closestLandmark(element);
        let nextLandmarkIndex = backward ? this.landmarks.length - 1 : 0;
        if (currentLandmark) nextLandmarkIndex = this.landmarks.indexOf(currentLandmark) + (backward ? -1 : 1);
        let wrapIfNeeded = ()=>{
            // When we reach the end of the landmark sequence, fire a custom event that can be listened for by applications.
            // If this event is canceled, we return immediately. This can be used to implement landmark navigation across iframes.
            if (nextLandmarkIndex < 0) {
                if (!element.dispatchEvent(new CustomEvent('react-aria-landmark-navigation', {
                    detail: {
                        direction: 'backward'
                    },
                    bubbles: true,
                    cancelable: true
                }))) return true;
                nextLandmarkIndex = this.landmarks.length - 1;
            } else if (nextLandmarkIndex >= this.landmarks.length) {
                if (!element.dispatchEvent(new CustomEvent('react-aria-landmark-navigation', {
                    detail: {
                        direction: 'forward'
                    },
                    bubbles: true,
                    cancelable: true
                }))) return true;
                nextLandmarkIndex = 0;
            }
            if (nextLandmarkIndex < 0 || nextLandmarkIndex >= this.landmarks.length) return true;
            return false;
        };
        if (wrapIfNeeded()) return undefined;
        // Skip over hidden landmarks.
        let i = nextLandmarkIndex;
        while(this.landmarks[nextLandmarkIndex].ref.current?.closest('[aria-hidden=true]')){
            nextLandmarkIndex += backward ? -1 : 1;
            if (wrapIfNeeded()) return undefined;
            if (nextLandmarkIndex === i) break;
        }
        return this.landmarks[nextLandmarkIndex];
    }
    /**
   * Look at next landmark. If an element was previously focused inside, restore focus there.
   * If not, focus the landmark itself.
   * If no landmarks at all, or none with focusable elements, don't move focus.
   */ f6Handler(e) {
        if (e.key === 'F6') {
            // If alt key pressed, focus main landmark, otherwise navigate forward or backward based on shift key.
            let handled = e.altKey ? this.focusMain() : this.navigate(e.target, e.shiftKey);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
    focusMain() {
        let main = this.getLandmarkByRole('main');
        if (main && main.ref.current && document.contains(main.ref.current)) {
            this.focusLandmark(main.ref.current, 'forward');
            return true;
        }
        return false;
    }
    navigate(from, backward) {
        let nextLandmark = this.getNextLandmark(from, {
            backward
        });
        if (!nextLandmark) return false;
        // If something was previously focused in the next landmark, then return focus to it
        if (nextLandmark.lastFocused) {
            let lastFocused = nextLandmark.lastFocused;
            if (document.body.contains(lastFocused)) {
                lastFocused.focus();
                return true;
            }
        }
        // Otherwise, focus the landmark itself
        if (nextLandmark.ref.current && document.contains(nextLandmark.ref.current)) {
            this.focusLandmark(nextLandmark.ref.current, backward ? 'backward' : 'forward');
            return true;
        }
        return false;
    }
    /**
   * Sets lastFocused for a landmark, if focus is moved within that landmark.
   * Lets the last focused landmark know it was blurred if something else is focused.
   */ focusinHandler(e) {
        let currentLandmark = this.closestLandmark(e.target);
        if (currentLandmark && currentLandmark.ref.current !== e.target) this.updateLandmark({
            ref: currentLandmark.ref,
            lastFocused: e.target
        });
        let previousFocusedElement = e.relatedTarget;
        if (previousFocusedElement) {
            let closestPreviousLandmark = this.closestLandmark(previousFocusedElement);
            if (closestPreviousLandmark && closestPreviousLandmark.ref.current === previousFocusedElement) closestPreviousLandmark.blur();
        }
    }
    /**
   * Track if the focus is lost to the body. If it is, do cleanup on the landmark that last had focus.
   */ focusoutHandler(e) {
        let previousFocusedElement = e.target;
        let nextFocusedElement = e.relatedTarget;
        // the === document seems to be a jest thing for focus to go there on generic blur event such as landmark.blur();
        // browsers appear to send focus instead to document.body and the relatedTarget is null when that happens
        if (!nextFocusedElement || nextFocusedElement === document) {
            let closestPreviousLandmark = this.closestLandmark(previousFocusedElement);
            if (closestPreviousLandmark && closestPreviousLandmark.ref.current === previousFocusedElement) closestPreviousLandmark.blur();
        }
    }
    createLandmarkController() {
        let instance = this;
        instance.refCount++;
        instance.setupIfNeeded();
        return {
            navigate (direction, opts) {
                let element = opts?.from || document.activeElement;
                return instance.navigate(element, direction === 'backward');
            },
            focusNext (opts) {
                let element = opts?.from || document.activeElement;
                return instance.navigate(element, false);
            },
            focusPrevious (opts) {
                let element = opts?.from || document.activeElement;
                return instance.navigate(element, true);
            },
            focusMain () {
                return instance.focusMain();
            },
            dispose () {
                if (instance) {
                    instance.refCount--;
                    instance.teardownIfNeeded();
                    instance = null;
                }
            }
        };
    }
    registerLandmark(landmark) {
        if (this.landmarks.find((l)=>l.ref === landmark.ref)) this.updateLandmark(landmark);
        else this.addLandmark(landmark);
        return ()=>this.removeLandmark(landmark.ref);
    }
}
function UNSTABLE_createLandmarkController() {
    // Get the current landmark manager and create a controller using it.
    let instance = getLandmarkManager();
    let controller = instance?.createLandmarkController();
    let unsubscribe = subscribe(()=>{
        // If the landmark manager changes, dispose the old
        // controller and create a new one.
        controller?.dispose();
        instance = getLandmarkManager();
        controller = instance?.createLandmarkController();
    });
    // Return a wrapper that proxies requests to the current controller instance.
    return {
        navigate (direction, opts) {
            return controller.navigate(direction, opts);
        },
        focusNext (opts) {
            return controller.focusNext(opts);
        },
        focusPrevious (opts) {
            return controller.focusPrevious(opts);
        },
        focusMain () {
            return controller.focusMain();
        },
        dispose () {
            controller?.dispose();
            unsubscribe();
            controller = undefined;
            instance = null;
        }
    };
}
function useLandmark(props, ref) {
    const { role, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, focus } = props;
    let manager = useLandmarkManager();
    let label = ariaLabel || ariaLabelledby;
    let [isLandmarkFocused, setIsLandmarkFocused] = (0, _react.useState)(false);
    let defaultFocus = (0, _react.useCallback)(()=>{
        setIsLandmarkFocused(true);
    }, [
        setIsLandmarkFocused
    ]);
    let blur = (0, _react.useCallback)(()=>{
        setIsLandmarkFocused(false);
    }, [
        setIsLandmarkFocused
    ]);
    (0, _utils.useLayoutEffect)(()=>{
        if (manager) return manager.registerLandmark({
            ref,
            label,
            role,
            focus: focus || defaultFocus,
            blur
        });
    }, [
        manager,
        label,
        ref,
        role,
        focus,
        defaultFocus,
        blur
    ]);
    (0, _react.useEffect)(()=>{
        if (isLandmarkFocused) ref.current?.focus();
    }, [
        isLandmarkFocused,
        ref
    ]);
    return {
        landmarkProps: {
            role,
            tabIndex: isLandmarkFocused ? -1 : undefined,
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabelledby
        }
    };
}

},{"react":"a1TxN","@react-aria/utils":"2ViQu","use-sync-external-store/shim/index.js":"iKEDy","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9o0L0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a toast queue. Toasts display brief, temporary notifications
 * of actions, errors, or other events in an application.
 */ parcelHelpers.export(exports, "useToastState", ()=>useToastState);
/**
 * Subscribes to a provided toast queue and provides methods to update it.
 */ parcelHelpers.export(exports, "useToastQueue", ()=>useToastQueue);
/**
 * A ToastQueue manages the order of toasts.
 */ parcelHelpers.export(exports, "ToastQueue", ()=>ToastQueue);
var _react = require("react");
// Shim to support React 17 and below.
var _indexJs = require("use-sync-external-store/shim/index.js");
function useToastState(props = {}) {
    let { maxVisibleToasts = 1, wrapUpdate } = props;
    let queue = (0, _react.useMemo)(()=>new ToastQueue({
            maxVisibleToasts,
            wrapUpdate
        }), [
        maxVisibleToasts,
        wrapUpdate
    ]);
    return useToastQueue(queue);
}
function useToastQueue(queue) {
    let subscribe = (0, _react.useCallback)((fn)=>queue.subscribe(fn), [
        queue
    ]);
    let getSnapshot = (0, _react.useCallback)(()=>queue.visibleToasts, [
        queue
    ]);
    let visibleToasts = (0, _indexJs.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return {
        visibleToasts,
        add: (content, options)=>queue.add(content, options),
        close: (key)=>queue.close(key),
        pauseAll: ()=>queue.pauseAll(),
        resumeAll: ()=>queue.resumeAll()
    };
}
class ToastQueue {
    constructor(options){
        this.queue = [];
        this.subscriptions = new Set();
        /** The currently visible toasts. */ this.visibleToasts = [];
        this.maxVisibleToasts = options?.maxVisibleToasts ?? Infinity;
        this.wrapUpdate = options?.wrapUpdate;
    }
    runWithWrapUpdate(fn, action) {
        if (this.wrapUpdate) this.wrapUpdate(fn, action);
        else fn();
    }
    /** Subscribes to updates to the visible toasts. */ subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    /** Adds a new toast to the queue. */ add(content, options = {}) {
        let toastKey = '_' + Math.random().toString(36).slice(2);
        let toast = {
            ...options,
            content,
            key: toastKey,
            timer: options.timeout ? new Timer(()=>this.close(toastKey), options.timeout) : undefined
        };
        this.queue.unshift(toast);
        this.updateVisibleToasts('add');
        return toastKey;
    }
    /**
   * Closes a toast.
   */ close(key) {
        let index = this.queue.findIndex((t)=>t.key === key);
        if (index >= 0) {
            this.queue[index].onClose?.();
            this.queue.splice(index, 1);
        }
        this.updateVisibleToasts('remove');
    }
    updateVisibleToasts(action) {
        this.visibleToasts = this.queue.slice(0, this.maxVisibleToasts);
        this.runWithWrapUpdate(()=>{
            for (let fn of this.subscriptions)fn();
        }, action);
    }
    /** Pauses the timers for all visible toasts. */ pauseAll() {
        for (let toast of this.visibleToasts)if (toast.timer) toast.timer.pause();
    }
    /** Resumes the timers for all visible toasts. */ resumeAll() {
        for (let toast of this.visibleToasts)if (toast.timer) toast.timer.resume();
    }
    clear() {
        this.queue = [];
        this.updateVisibleToasts('clear');
    }
}
class Timer {
    constructor(callback, delay){
        this.startTime = null;
        this.remaining = delay;
        this.callback = callback;
    }
    reset(delay) {
        this.remaining = delay;
        this.resume();
    }
    pause() {
        if (this.timerId == null) return;
        clearTimeout(this.timerId);
        this.timerId = null;
        this.remaining -= Date.now() - this.startTime;
    }
    resume() {
        if (this.remaining <= 0) return;
        this.startTime = Date.now();
        this.timerId = setTimeout(()=>{
            this.timerId = null;
            this.remaining = 0;
            this.callback();
        }, this.remaining);
    }
}

},{"react":"a1TxN","use-sync-external-store/shim/index.js":"iKEDy","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"62rTY":[function(require,module,exports,__globalThis) {
module.exports["background-toast"] = `wo0zeG_background-toast`;
module.exports["bottom"] = `wo0zeG_bottom`;
module.exports["end"] = `wo0zeG_end`;
module.exports["slide-in"] = `wo0zeG_slide-in`;
module.exports["slide-in"];
module.exports["slide-out"] = `wo0zeG_slide-out`;
module.exports["slide-out"];
module.exports["start"] = `wo0zeG_start`;
module.exports["toast"] = `wo0zeG_toast`;
module.exports["toast-action"] = `wo0zeG_toast-action`;
module.exports["toast-add"] = `wo0zeG_toast-add`;
module.exports["toast-background"] = `wo0zeG_toast-background`;
module.exports["toast-clear"] = `wo0zeG_toast-clear`;
module.exports["toast-close"] = `wo0zeG_toast-close`;
module.exports["toast-collapse"] = `wo0zeG_toast-collapse`;
module.exports["toast-content"] = `wo0zeG_toast-content`;
module.exports["toast-controls"] = `wo0zeG_toast-controls`;
module.exports["toast-expand"] = `wo0zeG_toast-expand`;
module.exports["toast-list-collapsed"] = `wo0zeG_toast-list-collapsed`;
module.exports["toast-list-expanded"] = `wo0zeG_toast-list-expanded`;
module.exports["toast-remove"] = `wo0zeG_toast-remove`;
module.exports["top"] = `wo0zeG_top`;

},{}],"jxfoI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalCardViewContext", ()=>InternalCardViewContext);
parcelHelpers.export(exports, "CardContext", ()=>CardContext);
parcelHelpers.export(exports, "Card", ()=>Card);
parcelHelpers.export(exports, "CardPreview", ()=>CardPreview);
parcelHelpers.export(exports, "CollectionCardPreview", ()=>CollectionCardPreview);
parcelHelpers.export(exports, "AssetCard", ()=>AssetCard);
parcelHelpers.export(exports, "UserCard", ()=>UserCard);
parcelHelpers.export(exports, "ProductCard", ()=>ProductCard);
var _jsxRuntime = require("react/jsx-runtime");
var _actionMenu = require("./ActionMenu");
var _avatar = require("./Avatar");
var _button = require("./Button");
var _checkbox = require("./Checkbox");
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _react = require("react");
var _divider = require("./Divider");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _image = require("./Image");
var _imageCoordinator = require("./ImageCoordinator");
var _runtime = require("../style/runtime");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const borderRadius = {
    default: 'lg',
    size: {
        XS: 'default',
        S: 'default'
    }
};
let card = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd12';
    rules += ' _ta12';
    if (!position) rules += ' _Pc12';
    if (props.size === "S") rules += ' ob12';
    else if (props.size === "XS") rules += ' ob12';
    else rules += ' oc12';
    if (props.size === "S") rules += ' nb12';
    else if (props.size === "XS") rules += ' nb12';
    else rules += ' nc12';
    if (props.size === "S") rules += ' kb12';
    else if (props.size === "XS") rules += ' kb12';
    else rules += ' kc12';
    if (props.size === "S") rules += ' jb12';
    else if (props.size === "XS") rules += ' jb12';
    else rules += ' jc12';
    if (props.variant === "secondary") rules += ' -Ovbhqd-gqlRAZb12';
    else if (props.variant === "primary") rules += ' -Ovbhqd-g_g12';
    rules += ' -Ovbhqd-lgb12';
    if (props.variant === "quiet") rules += ' g912';
    else if (props.variant === "tertiary") rules += ' g912';
    else rules += ' gEzkoQe12';
    if (props.variant === "quiet") rules += ' _nd12';
    else if (props.variant === "tertiary") {
        if (props.isSelected) rules += ' _nd12';
        else if (props.isFocusVisible) rules += ' _nrC99Ne12';
        else if (props.isHovered) rules += ' _nrC99Ne12';
        else rules += ' _nnvmtGb12';
        rules += ' _nlNRibY12';
    } else {
        if (props.isSelected) rules += ' _nLeasBb12';
        else if (props.isFocusVisible) rules += ' _nLeasBb12';
        else if (props.isHovered) rules += ' _nLeasBb12';
        else rules += ' _n4zCLMe12';
        rules += ' _nlAvWjK12';
    }
    rules += ' _yb12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' _Xa12';
    if (props.variant === "quiet") rules += ' _Ne12';
    else rules += ' _Nb12';
    if (props.variant === "quiet") rules += ' Pe12';
    else rules += ' Pb12';
    rules += ' _qc12';
    rules += ' __ca12';
    if (props.isCardView) rules += ' _4c12';
    if (props.isLink) rules += ' ry12';
    if (props.isCardView) {
        if (!width) rules += ' Za12';
    } else if (props.size === "XL") {
        if (!width) rules += ' ZA12';
    } else if (props.size === "L") {
        if (!width) rules += ' Zy12';
    } else if (props.size === "M") {
        if (!width) rules += ' Zt12';
    } else if (props.size === "S") {
        if (!width) rules += ' Zr12';
    } else if (props.size === "XS") {
        if (!width) rules += ' ZI12';
    }
    rules += ' Fb12';
    if (props.density === "spacious") {
        if (props.size === "XL") rules += ' -dAV6Jb-Ti12';
        else if (props.size === "L") rules += ' -dAV6Jb-Th12';
        else if (props.size === "M") rules += ' -dAV6Jb-Tg12';
        else if (props.size === "S") rules += ' -dAV6Jb-Tf12';
        else if (props.size === "XS") rules += ' -dAV6Jb-Te12';
    } else if (props.density === "regular") {
        if (props.size === "XL") rules += ' -dAV6Jb-Th12';
        else if (props.size === "L") rules += ' -dAV6Jb-Tg12';
        else if (props.size === "M") rules += ' -dAV6Jb-Tf12';
        else if (props.size === "S") rules += ' -dAV6Jb-Te12';
        else if (props.size === "XS") rules += ' -dAV6Jb-Tt12';
    } else if (props.density === "compact") {
        if (props.size === "XL") rules += ' -dAV6Jb-Tg12';
        else if (props.size === "L") rules += ' -dAV6Jb-Tf12';
        else if (props.size === "M") rules += ' -dAV6Jb-Te12';
        else if (props.size === "S") rules += ' -dAV6Jb-Tt12';
        else if (props.size === "XS") rules += ' -dAV6Jb-T1DOfn12';
    }
    if (props.variant === "quiet") rules += ' -jXLvjd-Td12';
    else rules += ' -jXLvjd-T5gMYHd12';
    if (props.variant === "quiet") rules += ' -iXLvjd-Sd12';
    else rules += ' -iXLvjd-S5gMYHd12';
    rules += ' TxTaQHd12';
    rules += ' QxTaQHd12';
    rules += ' S0SaQHd12';
    rules += ' R0SaQHd12';
    rules += ' _oa12';
    if (props.variant === "quiet") rules += ' _Le12';
    else if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    return rules;
};
let selectionIndicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa12';
    rules += ' Wr12';
    rules += ' _lr12';
    rules += ' _Ar12';
    rules += ' _zr12';
    rules += ' _9d12';
    if (props.size === "S") rules += ' ob12';
    else if (props.size === "XS") rules += ' ob12';
    else rules += ' oc12';
    if (props.size === "S") rules += ' nb12';
    else if (props.size === "XS") rules += ' nb12';
    else rules += ' nc12';
    if (props.size === "S") rules += ' kb12';
    else if (props.size === "XS") rules += ' kb12';
    else rules += ' kc12';
    if (props.size === "S") rules += ' jb12';
    else if (props.size === "XS") rules += ' jb12';
    else rules += ' jc12';
    rules += ' _Ob12';
    rules += ' _kc12';
    rules += ' hc12';
    rules += ' mc12';
    rules += ' lc12';
    rules += ' _jf12';
    rules += ' ik12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isSelected) rules += ' _Ib12';
    else rules += ' _Ia12';
    rules += ' OGcUfH12';
    rules += ' _Kc12';
    if (props.isStrokeInner) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' _Mc12';
    return rules;
};
let preview = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _Nb12';
    rules += ' Pb12';
    rules += ' I8cyuNb12';
    rules += ' H8cyuNb12';
    rules += ' J39J4qb12';
    rules += ' Gk39J4qb12';
    if (props.isQuiet) {
        if (props.size === "S") rules += ' ob12';
        else if (props.size === "XS") rules += ' ob12';
        else rules += ' oc12';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' nb12';
        else if (props.size === "XS") rules += ' nb12';
        else rules += ' nc12';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' kb12';
        else if (props.size === "XS") rules += ' kb12';
        else rules += ' kc12';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' jb12';
        else if (props.size === "XS") rules += ' jb12';
        else rules += ' jc12';
    }
    if (props.isQuiet) {
        if (props.isSelected) rules += ' _nLeasBb12';
        else if (props.isFocusVisible) rules += ' _nLeasBb12';
        else if (props.isHovered) rules += ' _nLeasBb12';
    }
    if (props.isQuiet) {
        if (props.isFocusVisible) rules += ' _Lf12';
    } else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    return rules;
};
const image = function anonymous(props) {
    let rules = " ";
    rules += ' Za12';
    if (props.layout === "grid") rules += ' fc12';
    rules += ' _Hb12';
    rules += ' _4c12';
    rules += ' _Ob12';
    return rules;
};
let title = function anonymous(props) {
    let rules = " ";
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    }
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    rules += ' xfd12';
    rules += ' _xfa12';
    rules += ' xfX0cczbc12';
    rules += ' _xfX0cczba12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    rules += ' po12';
    rules += ' __Ea12';
    rules += ' sa12';
    rules += ' __aa12';
    rules += ' __ba12';
    rules += ' zn9DOs12';
    rules += ' yn9DOs12';
    rules += ' Bn9DOs12';
    rules += ' An9DOs12';
    return rules;
};
let description = function anonymous(props) {
    let rules = " ";
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    }
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fb12';
    rules += ' _FnuYUwec12';
    rules += ' pt12';
    rules += ' __Ea12';
    rules += ' sa12';
    rules += ' __aa12';
    rules += ' __ba12';
    rules += ' z9u7zPc12';
    rules += ' y9u7zPc12';
    rules += ' B9u7zPc12';
    rules += ' A9u7zPc12';
    return rules;
};
let content = function anonymous(props) {
    let rules = " ";
    rules += ' se12';
    rules += ' DM8Mfn12';
    rules += ' DlsIuJI4ff412';
    rules += ' CfLapxc12';
    rules += ' ClsIuJg9IhLd12';
    rules += ' qb12';
    rules += ' _ub12';
    rules += ' ea12';
    rules += ' _cf12';
    if (props.size === "XL") rules += ' Ue12';
    else if (props.size === "L") rules += ' UWJpoB12';
    else if (props.size === "M") rules += ' UWJpoB12';
    else if (props.size === "S") rules += ' Ub12';
    else if (props.size === "XS") rules += ' Ub12';
    rules += ' T5gMYHd12';
    rules += ' Tbd12';
    rules += ' Q69YG2b12';
    rules += ' Qkd12';
    return rules;
};
let actionMenu = " zgSHDrc12 ygSHDrc12 BgSHDrc12 AgSHDrc12 JTnYEIe12 GTnYEIe12";
let footer = " sd12 _tc12 ec12 _Ce12 Ue12 qe12 T69YG2b12";
const InternalCardViewContext = /*#__PURE__*/ (0, _react.createContext)({
    ElementType: 'div',
    layout: 'grid'
});
const CardContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalCardContext = /*#__PURE__*/ (0, _react.createContext)({
    isQuiet: false,
    size: 'M',
    isSelected: false,
    isHovered: false,
    isFocusVisible: false,
    isPressed: false,
    isCheckboxSelection: true
});
const actionButtonSize = {
    XS: 'XS',
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const Card = /*#__PURE__*/ (0, _react.forwardRef)(function Card(props, ref) {
    [props] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CardContext);
    let { ElementType, layout } = (0, _react.useContext)(InternalCardViewContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { density = 'regular', size = 'M', variant = 'primary', UNSAFE_className = '', UNSAFE_style, styles, id, ...otherProps } = props;
    let isQuiet = variant === 'quiet';
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    let children = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _image.ImageContext),
                {
                    alt: '',
                    styles: image({
                        layout
                    })
                }
            ],
            [
                (0, _content.TextContext),
                {
                    slots: {
                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {},
                        title: {
                            styles: title({
                                size
                            })
                        },
                        description: {
                            styles: description({
                                size
                            })
                        }
                    }
                }
            ],
            [
                (0, _content.ContentContext),
                {
                    styles: content({
                        size
                    })
                }
            ],
            [
                (0, _divider.DividerContext),
                {
                    size: 'S'
                }
            ],
            [
                (0, _content.FooterContext),
                {
                    styles: footer
                }
            ],
            [
                (0, _actionMenu.ActionMenuContext),
                {
                    isQuiet: true,
                    size: actionButtonSize[size],
                    isDisabled: isSkeleton,
                    // @ts-ignore
                    'data-slot': 'menu',
                    styles: actionMenu
                }
            ],
            [
                (0, _skeleton.SkeletonContext),
                isSkeleton
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
            children: typeof props.children === 'function' ? props.children({
                size
            }) : props.children
        })
    });
    let press = (0, _pressScale.pressScale)(domRef, UNSAFE_style);
    if (ElementType === 'div' && !isSkeleton && props.href) // Standalone Card that has an href should be rendered as a Link.
    // NOTE: In this case, the card must not contain interactive elements.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...(0, _utils.filterDOMProps)(otherProps, {
            isLink: true
        }),
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + card({
                ...renderProps,
                size,
                density,
                variant,
                isCardView: false,
                isLink: true
            }, styles),
        style: (renderProps)=>// Only the preview in quiet cards scales down on press
            variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCardContext.Provider, {
                value: {
                    size,
                    isQuiet,
                    isCheckboxSelection: false,
                    isSelected: false,
                    ...renderProps
                },
                children: children
            })
    });
    if (ElementType === 'div' || isSkeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(otherProps),
        id: id != null ? String(id) : undefined,
        // @ts-ignore - React < 19 compat
        inert: (0, _utils.inertValue)(isSkeleton),
        ref: domRef,
        className: UNSAFE_className + card({
            size,
            density,
            variant,
            isCardView: ElementType !== 'div'
        }, styles),
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCardContext.Provider, {
            value: {
                size,
                isQuiet,
                isCheckboxSelection: false,
                isHovered: false,
                isFocusVisible: false,
                isSelected: false,
                isPressed: false
            },
            children: children
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ElementType, {
        ...props,
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + card({
                ...renderProps,
                isCardView: true,
                isLink: !!props.href,
                size,
                density,
                variant
            }, styles),
        style: (renderProps)=>// Only the preview in quiet cards scales down on press
            variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: ({ selectionMode, selectionBehavior, isHovered, isFocusVisible, isSelected, isPressed })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalCardContext.Provider, {
                value: {
                    size,
                    isQuiet,
                    isCheckboxSelection: selectionMode !== 'none' && selectionBehavior === 'toggle',
                    isHovered,
                    isFocusVisible,
                    isSelected,
                    isPressed
                },
                children: [
                    !isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
                    !isQuiet && selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sc12",
                        children: children
                    })
                ]
            })
    });
});
function SelectionIndicator() {
    let { size, isSelected, isQuiet, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: selectionIndicator({
            size,
            isSelected,
            // Add an inner stroke only for quiet cards with no checkbox to
            // help distinguish the selected state from the preview.
            isStrokeInner: isQuiet && !isCheckboxSelection
        })
    });
}
function CardCheckbox() {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " _Pa12 W5gMYHd12 _A5gMYHd12 _9d12 Tp12 Qp12 Sp12 Rp12 gGcUfH12 ob12 nb12 kb12 jb12 _n4zCLMe12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
            slot: "selection",
            excludeFromTabOrder: true,
            size: size === 'XS' ? 'S' : size
        })
    });
}
const CardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CardPreview(props, ref) {
    let { size, isQuiet, isHovered, isFocusVisible, isSelected, isPressed, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    let { UNSAFE_className = '', UNSAFE_style } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props),
        slot: "preview",
        ref: domRef,
        className: UNSAFE_className + preview({
            size,
            isQuiet,
            isHovered,
            isFocusVisible,
            isSelected
        }),
        style: isQuiet ? (0, _pressScale.pressScale)(domRef)({
            isPressed
        }) : UNSAFE_style,
        children: [
            isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
            isQuiet && isCheckboxSelection && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " oi12 ni12 ki12 ji12 _Nb12 Pb12",
                children: props.children
            })
        ]
    });
});
const collection = function anonymous(props) {
    let rules = " ";
    rules += ' se12';
    rules += ' DvhgoHd12';
    if (props.size === "S") rules += ' Ua12';
    else if (props.size === "XS") rules += ' Ua12';
    else rules += ' Ub12';
    if (props.size === "S") rules += ' qa12';
    else if (props.size === "XS") rules += ' qa12';
    else rules += ' qb12';
    return rules;
};
const collectionImage = " Za12 fa12 f5DbKFc12 y5DbKFwoofG12 _Hb12 _Ob12 _4c12";
const CollectionCardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CollectionCardPreview(props, ref) {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardPreview, {
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: collection({
                size
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _image.ImageContext).Provider, {
                value: {
                    styles: collectionImage
                },
                children: props.children
            })
        })
    });
});
const AssetCard = /*#__PURE__*/ (0, _react.forwardRef)(function AssetCard(props1, ref) {
    let { layout } = (0, _react.useContext)(InternalCardViewContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "regular",
        children: (0, _reactAriaComponents.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' Za12';
                                if (props.layout === "grid") rules += ' fa12';
                                rules += ' _Ha12';
                                rules += ' _Ob12';
                                rules += ' _4c12';
                                return rules;
                            }({
                                layout
                            })
                        }
                    ],
                    [
                        (0, _icon.IllustrationContext),
                        {
                            render (icon) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " sd12 eb12 _Ca12 gH12 fa12",
                                        children: icon
                                    })
                                });
                            },
                            styles: " Fd12 Le12 Ke12 Zc12"
                        }
                    ]
                ],
                children: children
            }))
    });
});
const avatarSize = {
    XS: 24,
    S: 48,
    M: 64,
    L: 64,
    XL: 80
};
const UserCard = /*#__PURE__*/ (0, _react.forwardRef)(function UserCard(props, ref) {
    let { size = 'M' } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props,
        ref: ref,
        density: "spacious",
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: " Za12 fb12 _Hb12 _Ob12 _4c12"
                        }
                    ],
                    [
                        (0, _avatar.AvatarContext),
                        {
                            size: avatarSize[size],
                            UNSAFE_style: {
                                '--size': avatarSize[size] / 16 + 'rem'
                            },
                            styles: " _Pc12 Jy12 Jkymupd0fnV8d12",
                            isOverBackground: true
                        }
                    ]
                ],
                children: children
            }))
    });
});
const buttonSize = {
    XS: 'S',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const ProductCard = /*#__PURE__*/ (0, _react.forwardRef)(function ProductCard(props1, ref) {
    let { size = 'M' } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "spacious",
        children: (0, _reactAriaComponents.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            slots: {
                                preview: {
                                    alt: '',
                                    styles: " Za12 fd12 _Hb12 _Ob12 _4c12"
                                },
                                thumbnail: {
                                    alt: '',
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' _Pc12';
                                        rules += ' _Ob12';
                                        rules += ' _4c12';
                                        if (props.size === "XL") rules += ' ZD12';
                                        else if (props.size === "L") rules += ' Zx12';
                                        else if (props.size === "M") rules += ' Zw12';
                                        else if (props.size === "S") rules += ' Zv12';
                                        else if (props.size === "XS") rules += ' Zo12';
                                        rules += ' FRuFGYc12';
                                        if (props.size === "S") rules += ' oa12';
                                        else if (props.size === "XS") rules += ' oa12';
                                        else rules += ' ob12';
                                        if (props.size === "S") rules += ' na12';
                                        else if (props.size === "XS") rules += ' na12';
                                        else rules += ' nb12';
                                        if (props.size === "S") rules += ' ka12';
                                        else if (props.size === "XS") rules += ' ka12';
                                        else rules += ' kb12';
                                        if (props.size === "S") rules += ' ja12';
                                        else if (props.size === "XS") rules += ' ja12';
                                        else rules += ' jb12';
                                        rules += ' _Hb12';
                                        rules += ' Jy12';
                                        rules += ' JkymupdLu7Bcc12';
                                        rules += ' _Lf12';
                                        if (props.size === "XS") rules += ' _Mb12';
                                        else rules += ' _Mc12';
                                        rules += ' OEzkoQe12';
                                        if (props.size === "XL") rules += ' -F_-Fy12';
                                        else if (props.size === "L") rules += ' -F_-Fw12';
                                        else if (props.size === "M") rules += ' -F_-Fv12';
                                        else if (props.size === "S") rules += ' -F_-Fu12';
                                        else if (props.size === "XS") rules += ' -F_-Fp12';
                                        return rules;
                                    }({
                                        size
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, _content.FooterContext),
                        {
                            styles: (0, _runtime.mergeStyles)(footer, " _Cb12")
                        }
                    ],
                    [
                        (0, _button.ButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ],
                    [
                        (0, _button.LinkButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ]
                ],
                children: children
            }))
    });
});

},{"0":"1aScm","1":"djnhn","2":"9JVds","3":"k13eK","4":"29keh","5":"8UvLf","6":"kf2At","7":"l7rkT","8":"km8Hh","9":"659Zi","10":"lPr3p","11":"5WSnw","12":"ijKky","13":"PONm7","14":"jyVFO","15":"alaq0","16":"8VyXK","17":"8qJIV","18":"cGMB8","19":"kPtpC","20":"cKCLH","21":"eqAcu","react/jsx-runtime":"2Is6Z","./ActionMenu":"3fSPo","./Avatar":"f3T9F","./Button":"gZHck","./Checkbox":"jdSVu","react-aria-components":[["composeRenderProps","bA6Cz"],["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["Link","fOCdV"]],"./Content":"10r6w","react":"a1TxN","./Divider":"kGk2u","@react-aria/utils":[["filterDOMProps","3upVm"],["inertValue","aL0AK"]],"./Icon":"jQAJE","./Image":"4LTiE","./ImageCoordinator":"3PQZz","../style/runtime":"8g9no","./pressScale":"8Ufux","./Skeleton":"1mUnF","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1aScm":[function() {},{}],"djnhn":[function() {},{}],"9JVds":[function() {},{}],"k13eK":[function() {},{}],"29keh":[function() {},{}],"8UvLf":[function() {},{}],"kf2At":[function() {},{}],"l7rkT":[function() {},{}],"km8Hh":[function() {},{}],"659Zi":[function() {},{}],"lPr3p":[function() {},{}],"5WSnw":[function() {},{}],"ijKky":[function() {},{}],"PONm7":[function() {},{}],"jyVFO":[function() {},{}],"alaq0":[function() {},{}],"8VyXK":[function() {},{}],"8qJIV":[function() {},{}],"cGMB8":[function() {},{}],"kPtpC":[function() {},{}],"cKCLH":[function() {},{}],"eqAcu":[function() {},{}],"3fSPo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenuContext", ()=>ActionMenuContext);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _react = require("react");
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _s2IconMore20NSvg = require("../s2wf-icons/S2_Icon_More_20_N.svg");
var _s2IconMore20NSvgDefault = parcelHelpers.interopDefault(_s2IconMore20NSvg);
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ActionMenuContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ActionMenu = /*#__PURE__*/ (0, _react.forwardRef)(function ActionMenu(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionMenuContext);
    let buttonProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    if (buttonProps['aria-label'] === undefined) buttonProps['aria-label'] = stringFormatter.format('menu.moreActions');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                ref: ref,
                size: props.size,
                isDisabled: props.isDisabled,
                autoFocus: props.autoFocus,
                isQuiet: props.isQuiet,
                styles: props.styles,
                ...buttonProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconMore20NSvgDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                items: props.items,
                disabledKeys: props.disabledKeys,
                onAction: props.onAction,
                size: props.menuSize,
                children: props.children
            })
        ]
    });
});

},{"react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","react":"a1TxN","@react-aria/utils":"3upVm","../intl/*.json":"gDH3q","./Menu":"1F0Yz","../s2wf-icons/S2_Icon_More_20_N.svg":"gP3id","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a5H2j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLibraryFromUrl", ()=>getLibraryFromUrl);
parcelHelpers.export(exports, "getLibraryFromPage", ()=>getLibraryFromPage);
parcelHelpers.export(exports, "getLibraryLabel", ()=>getLibraryLabel);
parcelHelpers.export(exports, "getLibraryIcon", ()=>getLibraryIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _internationalizedLogo = require("./icons/InternationalizedLogo");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaLogo = require("./icons/ReactAriaLogo");
function getLibraryFromUrl(url) {
    if (url.includes('/react-aria/')) return 'react-aria';
    if (url.includes('/internationalized/')) return 'internationalized';
    if (url.includes('/s2/')) return 'react-spectrum';
    return 'react-spectrum';
}
function getLibraryFromPage(page) {
    return getLibraryFromUrl(page.url);
}
function getLibraryLabel(library) {
    switch(library){
        case 'react-aria':
            return 'React Aria';
        case 'internationalized':
            return 'Internationalized';
        default:
            return 'React Spectrum';
    }
}
function getLibraryIcon(library) {
    switch(library){
        case 'react-aria':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {});
        case 'internationalized':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internationalizedLogo.InternationalizedLogo), {});
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {});
    }
}

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/InternationalizedLogo":"ge2ja","react":"a1TxN","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Bj5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdobeLogo", ()=>AdobeLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AdobeLogo = ({ className = '', size = 32 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        style: {
            width: size,
            height: size
        },
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 2",
        viewBox: "0 0 501.71 444.05",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z",
            "data-name": "Layer 1",
            className: " t4u0Crc12 _Va12"
        })
    });
};

},{"0":"7PUbU","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7PUbU":[function() {},{}],"ge2ja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternationalizedLogo", ()=>InternationalizedLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const InternationalizedLogo = ({ size = 32 })=>{
    const clipPathId = `internationalized-logo-clip-${(0, _react.useId)()}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_1",
        viewBox: "15 17 135 128",
        style: {
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: clipPathId,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.98 79.99c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.9 24 106.03 24 80.02Zm26.36-46.91c-.07-.17-.15-.33-.24-.49a55.64 55.64 0 0 1 12.37-5.84c.05.3.14.6.26.89 2.06 4.9 8.3 10.94 16.68 10.94 4.33 0 7.8-1.86 10.35-3.97 2.53-2.1 4.34-4.6 5.47-6.33.41-.63.62-1.34.65-2.04.69.2 1.37.42 2.05.65-.06.18-.1.37-.13.57-.67 4.46-1.44 10.7-.74 16.34.69 5.54 3.01 11.91 9.76 14.25 5.36 1.86 10.66.94 14.8-.9 2.74-1.22 5.23-2.96 7.07-4.9 2.11 3.7 3.81 7.65 5.04 11.81l-1.75-.36c-3.01-.59-7.06-1.26-11.28-1.54-4.16-.28-8.77-.19-12.78.91-4.02 1.1-8.1 3.44-9.84 8.13-4.86 13.11 1.7 21.06 3.39 22.75 2.55 2.55 5.17 3.75 7.1 4.62.23.11.46.21.67.31 1.86.87 3.19 1.63 4.54 3.58.47.67.94 1.89 1.3 3.74.34 1.8.52 3.89.58 6.11.07 2.2.02 4.41-.04 6.43l-.06 1.63c-.04 1.08-.07 2.1-.09 2.95a55.775 55.775 0 0 1-35.48 12.67c-2.09 0-4.15-.11-6.18-.34.44-.97.91-1.99 1.41-3.08.26-.55.52-1.12.79-1.71 1.15-2.49 2.37-5.21 3.44-7.97 2.05-5.28 3.89-11.54 2.82-16.9-.67-3.35-2.3-6.32-5.41-8.51-2.94-2.07-6.85-3.21-11.67-3.74-7.46-.83-10.89-1.6-14.01-4.09-2.9-2.32-3.62-4.43-3.74-5.93-.13-1.67.44-3.21 1-4.2.51-.9 1.72-1.68 4.44-1.97 2.35-.25 4.9-.03 7.3.18.31.03.62.05.93.08 2.86.24 5.98-.1 8.18-2.42 2.06-2.18 2.33-5.13 2.33-7.33 0-1.17.32-1.95.86-2.64.61-.79 1.63-1.6 3.26-2.51 2.83-1.57 4.87-4.32 5.4-7.4.56-3.26-.64-6.73-3.89-8.9-1.72-1.14-3.68-1.55-5.33-1.72-1.68-.17-3.48-.13-5.1-.08-.22 0-.44.01-.65.02-3.22.11-5.75.19-7.75-.38-.27-.08-.86-.38-1.74-1.22-.84-.8-1.72-1.89-2.58-3.15-1.73-2.53-3.12-5.37-3.79-7Zm73.36 81.97a55.79 55.79 0 0 0 12.32-35.06c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96Zm.28-69.78a56.276 56.276 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.96c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                            className: "st0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: `${clipPathId}-1`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.98 80c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.91 24 106.04 24 80.03Zm99.72 35.06A55.79 55.79 0 0 0 136.02 80c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96Zm.28-69.77a56.276 56.276 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.98c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                            className: "st0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                        children: '.st0{fill:none}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: `url(#${clipPathId})`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15 17h135v128H15z",
                    style: {
                        fill: '#6995fe'
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: `url(#${clipPathId}-1)`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15 17.01h135v128H15z",
                    style: {
                        fill: '#099d59'
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iQPne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactAriaLogo", ()=>ReactAriaLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ReactAriaLogo = ({ size = 32 })=>{
    const clipPathId = `react-aria-logo-clip-${(0, _react.useId)()}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "15.79 17.64 131.21 126.14",
        style: {
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: clipPathId,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M80 136c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56Zm8.48-86.3c0 4.69-3.8 8.48-8.48 8.48s-8.48-3.8-8.48-8.48 3.8-8.48 8.48-8.48 8.48 3.8 8.48 8.48ZM51.09 61.78c.52-1.8 2.39-2.85 4.2-2.33a89.865 89.865 0 0 0 48.82.17l.64-.18c1.81-.5 3.68.55 4.18 2.36a3.39 3.39 0 0 1-2.36 4.18l-.64.18a97.139 97.139 0 0 1-15.51 2.98c-1.03.11-1.82.97-1.82 2.01v14.89c0 .18.03.37.08.55 1.37 4.83 2.94 10.39 4.32 15.27.98 3.46 1.86 6.58 2.49 8.85.32 1.14.58 2.06.76 2.71l.04.15c.13.48.27.97.31 1.16a3.38 3.38 0 0 1-2.66 3.99 3.38 3.38 0 0 1-3.99-2.66c.02.09 0 .04-.08-.27-.04-.13-.09-.31-.15-.54-.18-.65-.44-1.57-.76-2.7-.64-2.27-1.52-5.39-2.49-8.85l-3.74-13.21a1.992 1.992 0 0 0-1.92-1.45h-1.6c-.89 0-1.68.59-1.92 1.45-1.22 4.3-2.55 9.01-3.74 13.21-.98 3.46-1.85 6.58-2.49 8.85-.32 1.13-.58 2.06-.76 2.7-.06.23-.11.41-.15.54-.09.31-.1.36-.08.27a3.39 3.39 0 1 1-6.65-1.33c.04-.18.18-.68.31-1.16l.04-.15c.18-.65.44-1.58.76-2.71.64-2.27 1.52-5.39 2.49-8.85 1.38-4.88 2.95-10.44 4.32-15.27.05-.18.08-.36.08-.55V71.16c0-1.04-.79-1.9-1.82-2.01a96.504 96.504 0 0 1-16.17-3.17 3.395 3.395 0 0 1-2.33-4.2Z",
                        style: {
                            fill: 'none'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 80,
                cy: 80,
                r: 50.83,
                style: {
                    fill: '#fff'
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: `url(#${clipPathId})`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15.79 17.64H147v126.14H15.79z",
                    style: {
                        fill: '#269ff4'
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ahti0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsContext", ()=>TabsContext);
parcelHelpers.export(exports, "TabListStateContext", ()=>TabListStateContext);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
parcelHelpers.export(exports, "TabList", ()=>TabList);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "TabPanels", ()=>TabPanels);
parcelHelpers.export(exports, "TabPanel", ()=>TabPanel);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _collection = require("./Collection");
var _utils1 = require("@react-aria/utils");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectionIndicator = require("./SelectionIndicator");
var _sharedElementTransition = require("./SharedElementTransition");
const TabsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TabListStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Tabs = /*#__PURE__*/ (0, _react.forwardRef)(function Tabs(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TabsContext);
    let { children, orientation = 'horizontal' } = props;
    children = (0, _react.useMemo)(()=>typeof children === 'function' ? children({
            orientation,
            defaultChildren: null
        }) : children, [
        children,
        orientation
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.CollectionBuilder), {
        content: children
    }, (collection)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TabsInner, {
            props: props,
            collection: collection,
            tabsRef: ref
        }));
});
function TabsInner({ props, tabsRef: ref, collection }) {
    let { orientation = 'horizontal' } = props;
    let state = (0, _reactStately.useTabListState)({
        ...props,
        collection,
        children: undefined
    });
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let values = (0, _react.useMemo)(()=>({
            orientation,
            isFocusWithin: isFocused,
            isFocusVisible
        }), [
        orientation,
        isFocused,
        isFocusVisible
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Tabs',
        values
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-orientation": orientation,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": state.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TabsContext,
                props
            ],
            [
                TabListStateContext,
                state
            ]
        ]
    }, renderProps.children));
}
const TabList = /*#__PURE__*/ (0, _react.forwardRef)(function TabList(props, ref) {
    let state = (0, _react.useContext)(TabListStateContext);
    return state ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TabListInner, {
        props: props,
        forwardedRef: ref
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Collection), props);
});
function TabListInner({ props, forwardedRef: ref }) {
    let state = (0, _react.useContext)(TabListStateContext);
    let { CollectionRoot } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let { orientation = 'horizontal', keyboardActivation = 'automatic' } = (0, _utils.useSlottedContext)(TabsContext);
    let objectRef = (0, _utils1.useObjectRef)(ref);
    let { tabListProps } = (0, _reactAria.useTabList)({
        ...props,
        orientation,
        keyboardActivation
    }, state, objectRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        children: null,
        defaultClassName: 'react-aria-TabList',
        values: {
            orientation,
            state
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, tabListProps),
        ref: objectRef,
        "data-orientation": orientation || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sharedElementTransition.SharedElementTransition), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, _collection.usePersistedKeys)(state.selectionManager.focusedKey)
    })));
}
class TabItemNode extends (0, _collections.CollectionNode) {
    static{
        this.type = 'item';
    }
}
const Tab = /*#__PURE__*/ (0, _collections.createLeafComponent)(TabItemNode, (props, forwardedRef, item)=>{
    let state = (0, _react.useContext)(TabListStateContext);
    let ref = (0, _utils1.useObjectRef)(forwardedRef);
    let { tabProps, isSelected, isDisabled, isPressed } = (0, _reactAria.useTab)({
        key: item.key,
        ...props
    }, state, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled,
        onHoverStart: props.onHoverStart,
        onHoverEnd: props.onHoverEnd,
        onHoverChange: props.onHoverChange
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-Tab',
        values: {
            isSelected,
            isDisabled,
            isFocused,
            isFocusVisible,
            isPressed,
            isHovered
        }
    });
    let ElementType = item.props.href ? 'a' : 'div';
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ElementType, {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, tabProps, focusProps, hoverProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectionIndicator.SelectionIndicatorContext).Provider, {
        value: {
            isSelected
        }
    }, renderProps.children));
});
const TabPanels = /*#__PURE__*/ (0, _collections.createHideableComponent)(function TabPanels(props, forwardedRef) {
    let state = (0, _react.useContext)(TabListStateContext);
    let ref = (0, _utils1.useObjectRef)(forwardedRef);
    let selectedKeyRef = (0, _react.useRef)(state.selectedKey);
    let prevSize = (0, _react.useRef)(null);
    let hasTransition = (0, _react.useRef)(null);
    (0, _utils1.useLayoutEffect)(()=>{
        let el = ref.current;
        if (!el) return;
        if (hasTransition.current == null) hasTransition.current = /width|height|all/.test(window.getComputedStyle(el).transition);
        if (hasTransition.current && selectedKeyRef.current != null && selectedKeyRef.current !== state.selectedKey) {
            // Measure auto size.
            el.style.setProperty('--tab-panel-width', 'auto');
            el.style.setProperty('--tab-panel-height', 'auto');
            let { width, height } = el.getBoundingClientRect();
            if (prevSize.current && (prevSize.current.width !== width || prevSize.current.height !== height)) {
                // Revert to previous size.
                el.style.setProperty('--tab-panel-width', prevSize.current.width + 'px');
                el.style.setProperty('--tab-panel-height', prevSize.current.height + 'px');
                // Force style re-calculation to trigger animations.
                window.getComputedStyle(el).height;
                // Animate to current pixel size.
                el.style.setProperty('--tab-panel-width', width + 'px');
                el.style.setProperty('--tab-panel-height', height + 'px');
                // When animations complete, revert back to auto size.
                Promise.all(el.getAnimations().map((a)=>a.finished)).then(()=>{
                    el.style.setProperty('--tab-panel-width', 'auto');
                    el.style.setProperty('--tab-panel-height', 'auto');
                }).catch(()=>{});
            }
        }
        selectedKeyRef.current = state.selectedKey;
    }, [
        ref,
        state.selectedKey
    ]);
    // Store previous size before DOM updates occur.
    // This breaks the rules of hooks because there is no effect that runs _before_ DOM updates.
    // eslint-disable-next-line rulesdir/pure-render
    if (state.selectedKey != null && state.selectedKey !== selectedKeyRef.current && ref.current && hasTransition.current) // eslint-disable-next-line rulesdir/pure-render
    prevSize.current = ref.current.getBoundingClientRect();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...props,
        ref: ref,
        className: props.className || 'react-aria-TabPanels'
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Collection), props));
});
const TabPanel = /*#__PURE__*/ (0, _collections.createHideableComponent)(function TabPanel(props, forwardedRef) {
    const state = (0, _react.useContext)(TabListStateContext);
    let ref = (0, _utils1.useObjectRef)(forwardedRef);
    // Track if the tab panel was initially selected on mount (after extra render to populate the collection).
    // In this case, we don't want to trigger animations.
    let isSelected = state.selectedKey === props.id;
    let [isInitiallySelected, setInitiallySelected] = (0, _react.useState)(state.selectedKey != null ? isSelected : null);
    if (isInitiallySelected == null && state.selectedKey != null) setInitiallySelected(isSelected);
    else if (!isSelected && isInitiallySelected) setInitiallySelected(false);
    let isExiting = (0, _utils1.useExitAnimation)(ref, isSelected);
    if (!isSelected && !props.shouldForceMount && !isExiting) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TabPanelInner, {
        ...props,
        tabPanelRef: ref,
        isInitiallySelected: isInitiallySelected || false,
        isExiting: isExiting
    });
});
function TabPanelInner(props) {
    let state = (0, _react.useContext)(TabListStateContext);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { id, tabPanelRef: ref, isInitiallySelected, isExiting, ...otherProps } = props;
    let { tabPanelProps } = (0, _reactAria.useTabPanel)(props, state, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let isSelected = state.selectedKey === props.id;
    let isEntering = (0, _utils1.useEnterAnimation)(ref) && !isInitiallySelected;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-TabPanel',
        values: {
            isFocused,
            isFocusVisible,
            // @ts-ignore - compatibility with React < 19
            isInert: (0, _utils1.inertValue)(!isSelected),
            isEntering,
            isExiting,
            state
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(otherProps, {
        global: true
    });
    delete DOMProps.id;
    let domProps = isSelected ? (0, _reactAria.mergeProps)(DOMProps, tabPanelProps, focusProps, renderProps) : (0, _reactAria.mergeProps)(DOMProps, renderProps);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...domProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        // @ts-ignore
        inert: (0, _utils1.inertValue)(!isSelected || props.inert),
        "data-inert": !isSelected ? 'true' : undefined,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TabsContext,
                null
            ],
            [
                TabListStateContext,
                null
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.CollectionRendererContext).Provider, {
        value: (0, _collection.DefaultCollectionRenderer)
    }, renderProps.children)));
}

},{"react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useTab","2gDnK"],["useTabList","i090g"],["useTabPanel","7Q6Nd"]],"./utils":"bA6Cz","@react-aria/collections":[["Collection","2Jd0Q"],["CollectionBuilder","2Jd0Q"],["createLeafComponent","2Jd0Q"],["CollectionNode","ab6Rh"],["createHideableComponent","jY1vZ"]],"./Collection":"7QyMy","@react-aria/utils":[["filterDOMProps","3upVm"],["inertValue","aL0AK"],["useEnterAnimation","a1dBG"],["useExitAnimation","a1dBG"],["useLayoutEffect","2ViQu"],["useObjectRef","laqO5"]],"react-stately":"stm5y","react":"a1TxN","./SelectionIndicator":"dgQU7","./SharedElementTransition":"iVZnk","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2gDnK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tab.
 * When selected, the associated tab panel is shown.
 */ parcelHelpers.export(exports, "useTab", ()=>useTab);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useTab(props, state, ref) {
    let { key, isDisabled: propsDisabled, shouldSelectOnPressUp } = props;
    let { selectionManager: manager, selectedKey } = state;
    let isSelected = key === selectedKey;
    let isDisabled = propsDisabled || state.isDisabled || state.selectionManager.isDisabled(key);
    let { itemProps, isPressed } = (0, _selection.useSelectableItem)({
        selectionManager: manager,
        key,
        ref,
        isDisabled,
        shouldSelectOnPressUp,
        linkBehavior: 'selection'
    });
    let tabId = (0, _utils1.generateId)(state, key, 'tab');
    let tabPanelId = (0, _utils1.generateId)(state, key, 'tabpanel');
    let { tabIndex } = itemProps;
    let item = state.collection.getItem(key);
    let domProps = (0, _utils.filterDOMProps)(item?.props, {
        labelable: true
    });
    delete domProps.id;
    let linkProps = (0, _utils.useLinkProps)(item?.props);
    let { focusableProps } = (0, _focus.useFocusable)({
        isDisabled
    }, ref);
    return {
        tabProps: (0, _utils.mergeProps)(domProps, focusableProps, linkProps, itemProps, {
            id: tabId,
            'aria-selected': isSelected,
            'aria-disabled': isDisabled || undefined,
            'aria-controls': isSelected ? tabPanelId : undefined,
            tabIndex: isDisabled ? undefined : tabIndex,
            role: 'tab'
        }),
        isSelected,
        isDisabled,
        isPressed
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useLinkProps","4FGnT"]],"./utils":"e8RXa","@react-aria/focus":"kCQqy","@react-aria/selection":"cJdJS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e8RXa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabsIds", ()=>tabsIds);
parcelHelpers.export(exports, "generateId", ()=>generateId);
const tabsIds = new WeakMap();
function generateId(state, key, role) {
    if (!state) // this case should only happen in the first render before the tabs are registered
    return '';
    if (typeof key === 'string') key = key.replace(/\s+/g, '');
    let baseId = tabsIds.get(state);
    return `${baseId}-${role}-${key}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i090g":[function(require,module,exports,__globalThis) {
/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tab list.
 * Tabs organize content into multiple sections and allow users to navigate between them.
 */ parcelHelpers.export(exports, "useTabList", ()=>useTabList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _tabsKeyboardDelegate = require("./TabsKeyboardDelegate");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
var _selection = require("@react-aria/selection");
function useTabList(props, state, ref) {
    let { orientation = 'horizontal', keyboardActivation = 'automatic' } = props;
    let { collection, selectionManager: manager, disabledKeys } = state;
    let { direction } = (0, _i18N.useLocale)();
    let delegate = (0, _react.useMemo)(()=>new (0, _tabsKeyboardDelegate.TabsKeyboardDelegate)(collection, direction, orientation, disabledKeys), [
        collection,
        disabledKeys,
        orientation,
        direction
    ]);
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        selectOnFocus: keyboardActivation === 'automatic',
        disallowEmptySelection: true,
        scrollRef: ref,
        linkBehavior: 'selection'
    });
    // Compute base id for all tabs
    let tabsId = (0, _utils.useId)();
    (0, _utils1.tabsIds).set(state, tabsId);
    let tabListLabelProps = (0, _utils.useLabels)({
        ...props,
        id: tabsId
    });
    return {
        tabListProps: {
            ...(0, _utils.mergeProps)(collectionProps, tabListLabelProps),
            role: 'tablist',
            'aria-orientation': orientation,
            tabIndex: undefined
        }
    };
}

},{"@react-aria/utils":[["mergeProps","aNvcY"],["useId","jbI4Y"],["useLabels","7Uhyw"]],"./utils":"e8RXa","./TabsKeyboardDelegate":"l53H0","@react-aria/i18n":"4k4z8","react":"a1TxN","@react-aria/selection":"agala","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l53H0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsKeyboardDelegate", ()=>TabsKeyboardDelegate);
class TabsKeyboardDelegate {
    constructor(collection, direction, orientation, disabledKeys = new Set()){
        this.collection = collection;
        this.flipDirection = direction === 'rtl' && orientation === 'horizontal';
        this.disabledKeys = disabledKeys;
        this.tabDirection = orientation === 'horizontal';
    }
    getKeyLeftOf(key) {
        if (this.flipDirection) return this.getNextKey(key);
        return this.getPreviousKey(key);
    }
    getKeyRightOf(key) {
        if (this.flipDirection) return this.getPreviousKey(key);
        return this.getNextKey(key);
    }
    isDisabled(key) {
        return this.disabledKeys.has(key) || !!this.collection.getItem(key)?.props?.isDisabled;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        if (key != null && this.isDisabled(key)) key = this.getNextKey(key);
        return key;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        if (key != null && this.isDisabled(key)) key = this.getPreviousKey(key);
        return key;
    }
    getKeyAbove(key) {
        if (this.tabDirection) return null;
        return this.getPreviousKey(key);
    }
    getKeyBelow(key) {
        if (this.tabDirection) return null;
        return this.getNextKey(key);
    }
    getNextKey(startKey) {
        let key = startKey;
        do {
            key = this.collection.getKeyAfter(key);
            if (key == null) key = this.collection.getFirstKey();
        }while (key != null && this.isDisabled(key));
        return key;
    }
    getPreviousKey(startKey) {
        let key = startKey;
        do {
            key = this.collection.getKeyBefore(key);
            if (key == null) key = this.collection.getLastKey();
        }while (key != null && this.isDisabled(key));
        return key;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7Q6Nd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tab panel. A tab panel is a container for
 * the contents of a tab, and is shown when the tab is selected.
 */ parcelHelpers.export(exports, "useTabPanel", ()=>useTabPanel);
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
function useTabPanel(props, state, ref) {
    // The tabpanel should have tabIndex=0 when there are no tabbable elements within it.
    // Otherwise, tabbing from the focused tab should go directly to the first tabbable element
    // within the tabpanel.
    let tabIndex = (0, _focus.useHasTabbableChild)(ref) ? undefined : 0;
    const id = (0, _utils.generateId)(state, props.id ?? state?.selectedKey, 'tabpanel');
    const tabPanelProps = (0, _utils1.useLabels)({
        ...props,
        id,
        'aria-labelledby': (0, _utils.generateId)(state, state?.selectedKey, 'tab')
    });
    return {
        tabPanelProps: (0, _utils1.mergeProps)(tabPanelProps, {
            tabIndex,
            role: 'tabpanel',
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details']
        })
    };
}

},{"./utils":"e8RXa","@react-aria/utils":[["mergeProps","aNvcY"],["useLabels","7Uhyw"]],"@react-aria/focus":"eSQu0","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eSQu0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This was created for a special empty case of a component that can have child or
// be empty, like Collection/Virtualizer/Table/ListView/etc. When these components
// are empty they can have a message with a tabbable element, which is like them
// being not empty, when it comes to focus and tab order.
/**
 * Returns whether an element has a tabbable child, and updates as children change.
 * @private
 */ parcelHelpers.export(exports, "useHasTabbableChild", ()=>useHasTabbableChild);
var _focusScope = require("./FocusScope");
var _utils = require("@react-aria/utils");
var _react = require("react");
function useHasTabbableChild(ref, options) {
    let isDisabled = options?.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, _react.useState)(false);
    (0, _utils.useLayoutEffect)(()=>{
        if (ref?.current && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, _focusScope.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    'tabIndex',
                    'disabled'
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

},{"./FocusScope":"9oPIl","@react-aria/utils":"2ViQu","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"stm5y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a Tabs component. Tabs include a TabList which tracks
 * which tab is currently selected and displays the content associated with that Tab in a TabPanel.
 */ parcelHelpers.export(exports, "useTabListState", ()=>useTabListState);
var _list = require("@react-stately/list");
var _react = require("react");
function useTabListState(props) {
    let state = (0, _list.useSingleSelectListState)({
        ...props,
        onSelectionChange: props.onSelectionChange ? (key)=>{
            if (key != null) props.onSelectionChange?.(key);
        } : undefined,
        suppressTextValueWarning: true,
        defaultSelectedKey: props.defaultSelectedKey ?? findDefaultSelectedKey(props.collection, props.disabledKeys ? new Set(props.disabledKeys) : new Set()) ?? undefined
    });
    let { selectionManager, collection, selectedKey: currentSelectedKey } = state;
    let lastSelectedKey = (0, _react.useRef)(currentSelectedKey);
    (0, _react.useEffect)(()=>{
        // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)
        let selectedKey = currentSelectedKey;
        if (props.selectedKey == null && (selectionManager.isEmpty || selectedKey == null || !collection.getItem(selectedKey))) {
            selectedKey = findDefaultSelectedKey(collection, state.disabledKeys);
            if (selectedKey != null) // directly set selection because replace/toggle selection won't consider disabled keys
            selectionManager.setSelectedKeys([
                selectedKey
            ]);
        }
        // If the tablist doesn't have focus and the selected key changes or if there isn't a focused key yet, change focused key to the selected key if it exists.
        if (selectedKey != null && selectionManager.focusedKey == null || !selectionManager.isFocused && selectedKey !== lastSelectedKey.current) selectionManager.setFocusedKey(selectedKey);
        lastSelectedKey.current = selectedKey;
    });
    return {
        ...state,
        isDisabled: props.isDisabled || false
    };
}
function findDefaultSelectedKey(collection, disabledKeys) {
    let selectedKey = null;
    if (collection) {
        selectedKey = collection.getFirstKey();
        // loop over tabs until we find one that isn't disabled and select that
        while(selectedKey != null && (disabledKeys.has(selectedKey) || collection.getItem(selectedKey)?.props?.isDisabled) && selectedKey !== collection.getLastKey())selectedKey = collection.getKeyAfter(selectedKey);
        // if this check is true, then every item is disabled, it makes more sense to default to the first key than the last
        if (selectedKey != null && (disabledKeys.has(selectedKey) || collection.getItem(selectedKey)?.props?.isDisabled) && selectedKey === collection.getLastKey()) selectedKey = collection.getFirstKey();
    }
    return selectedKey;
}

},{"@react-stately/list":"c6gMj","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _internationalizedLogo = require("./icons/InternationalizedLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    },
    'internationalized': {
        label: 'Internationalized',
        description: 'Framework-agnostic internationalization utilities',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internationalizedLogo.InternationalizedLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/InternationalizedLogo":"ge2ja","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=error.84b563d0.js.map
